// src/host.tsx
import React from "react";
import { jsx } from "react/jsx-runtime";
var RidehailsHostContext = React.createContext(null);
var RidehailsHostProvider = ({
  host,
  children
}) => /* @__PURE__ */ jsx(RidehailsHostContext.Provider, { value: host, children });
var useRidehailsHost = () => {
  const host = React.useContext(RidehailsHostContext);
  if (!host) {
    throw new Error(
      "useRidehailsHost: no RidehailsHostProvider above this component \u2014 wrap the page in one (see the dealer/embed RidehailsPage)."
    );
  }
  return host;
};

// src/providers/RidehailsProvider.tsx
import React2, { createContext, useContext, useState, useCallback } from "react";
import dayjs from "dayjs";
import { Chip } from "@mui/material";
import { BiSolidCheckCircle, BiSolidXCircle, BiTime } from "react-icons/bi";

// src/lib/logos.ts
var uberLogo = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNTAgODYuODYiPjxnIGlkPSJMYXllcl8yIiBkYXRhLW5hbWU9IkxheWVyIDIiPjxnIGlkPSJ1YmVyIj48cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIGQ9Ik03Ny4yNCw4NS4zNVYuMTFIODkuMzhWMzAuODZjOC43Ny03Ljk1LDE4LjUxLTEwLjY5LDI5LjU0LTguMjNBMzEsMzEsMCwwLDEsMTM3LjgzLDM1LDMyLjQ3LDMyLjQ3LDAsMCwxLDg5LjQsNzcuOTJ2Ny40M0g3Ny4yNFptMzMuNDItNTIuNDhjLTExLjQxLS40NS0yMS41Myw5LjMtMjEuNDgsMjEuNDNhMjEuMzUsMjEuMzUsMCwxLDAsNDIuNjkuMDZDMTMyLDQyLjI5LDEyMS44MSwzMi40NywxMTAuNjYsMzIuODdaIi8+PHBhdGggZmlsbD0iY3VycmVudENvbG9yIiBkPSJNLjE1LjA5SDEyLjg3VjIuNDdxMCwyNS4yOSwwLDUwLjU4YzAsNi4xNCwxLjc5LDExLjcxLDYuMTMsMTYuMjMsMTAuNDEsMTAuODQsMjkuNTIsNi41NiwzNC4xNi03Ljc0YTMwLjE3LDMwLjE3LDAsMCwwLDEuNDgtOWMuMTQtMTYuNjYuMDctMzMuMzMuMDctNTBWMGM0LjA3LDAsOCwwLDExLjkzLDAsLjI4LDAsLjcuNS43OS44M2E3LjQ3LDcuNDcsMCwwLDEsLjA2LDEuNzFWODIuODZjMCwyLjQ5LDAsMi40OS0yLjUsMi40OS0yLjY4LDAtNS4zNy0uMDktOCwwLTEuNjMuMDgtMi4zNC0uMzMtMi4xOC0yLjFzMC0zLjQyLDAtNS40N2MtMS43MiwxLjM0LTMuMTUsMi41Ni00LjcsMy42MS04LDUuNDEtMTYuOTIsNi42NC0yNi4xNyw0LjM1QzEzLjMxLDgzLjE0LDUuODUsNzYuNTUsMi4yNyw2Ni4xMkEzOC41NywzOC41NywwLDAsMSwuMTQsNTQuMzRDLS4wOSwzNi43MiwwLDE5LjA5LDAsMS40NiwwLDEuMDkuMS43MS4xNS4wOVoiLz48cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIGQ9Ik0yMTIuMjksNTguMjlIMTYxLjQyYzEuNjgsNy45LDUuODIsMTMuNTcsMTMuMTUsMTYuMTksMTAsMy41OCwxOC41LjY5LDI1LjQyLTcuNjNsOC44Miw2LjQ4YTMyLjcsMzIuNywwLDAsMS0xMiwxMC4wN2MtMTIuNjYsNi4zMy0yOS40NCwzLjM3LTM5LjE4LTYuODlDMTQxLjI3LDU5LjI0LDE0OSwzMCwxNzEuOCwyMy4yMWMxOC01LjMzLDM2LjI4LDUuMTcsMzkuNTUsMjQuNDNDMjExLjkzLDUxLjA1LDIxMiw1NC41NiwyMTIuMjksNTguMjlabS0xMy05LjlhMTguNzQsMTguNzQsMCwwLDAtMTkuMTMtMTUuNjhjLTkuMjkuNDItMTguNDUsOC40Mi0xOC4xMiwxNS42OFoiLz48cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIGQ9Ik0yMzEuMTcsODUuMjRIMjE4LjkzVjIzLjE2aDEydjYuNjdsLjQyLjI5YzQuNTgtNi42NSwxMS4xNC04LDE4LjY0LTcuNFYzMy44OWMtMi40My4xNS00Ljg0LjE1LTcuMjEuNDctNS40Mi43Mi04Ljg4LDQtMTAuNTEsOWEyNC43LDI0LjcsMCwwLDAtMS4wNiw3LjMyYy0uMTEsMTAuNzItLjA1LDIxLjQ0LS4wNSwzMi4xN1oiLz48L2c+PC9nPjwvc3ZnPg==";
var lyftLogo = "data:image/svg+xml;base64,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";

// src/providers/RidehailsProvider.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var RidehailsContext = createContext(void 0);
var RidehailsProvider = ({ children }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    range: "thisweek",
    fromDate: dayjs().startOf("week").toISOString(),
    toDate: dayjs().endOf("week").toISOString(),
    searchText: "",
    provider: "",
    status: "",
    metric: "all"
  });
  const updateFilters = useCallback((newFilters) => {
    setFilters((prev) => ({ ...prev, ...newFilters }));
  }, []);
  const isPickupWithinLastDay2 = (pickupTime) => {
    if (!pickupTime) return false;
    const oneDayAgo = dayjs().subtract(1, "day");
    const pickup = dayjs(pickupTime);
    return pickup.isAfter(oneDayAgo);
  };
  const filteredData = React2.useMemo(() => {
    let filtered = [...data];
    if (filters.fromDate || filters.toDate) {
      const fromDate = filters.fromDate ? dayjs(filters.fromDate) : null;
      const toDate = filters.toDate ? dayjs(filters.toDate) : null;
      filtered = filtered.filter((ridehail) => {
        const dateStr = ridehail?.created_at || ridehail?.move?.ready_by;
        if (!dateStr) return false;
        const date = dayjs(dateStr);
        if (fromDate && date.isBefore(fromDate)) return false;
        if (toDate && date.isAfter(toDate)) return false;
        return true;
      });
    }
    if (filters.metric && filters.metric !== "all") {
      if (filters.metric === "pending") {
        filtered = filtered.filter((ridehail) => {
          const pickupTime = ridehail?.pickup_at || ridehail?.move?.ready_by;
          return ridehail?.status === "Not Called" && pickupTime && isPickupWithinLastDay2(pickupTime);
        });
      } else if (filters.metric === "not_called") {
        filtered = filtered.filter((ridehail) => {
          const pickupTime = ridehail?.pickup_at || ridehail?.move?.ready_by;
          return ridehail?.status === "Not Called" && (!pickupTime || !isPickupWithinLastDay2(pickupTime));
        });
      } else if (filters.metric === "failed") {
        filtered = filtered.filter((ridehail) => {
          const status = ridehail?.status?.toLowerCase();
          return status === "failed" || status === "retry";
        });
      } else if (filters.metric === "canceled") {
        filtered = filtered.filter((ridehail) => {
          const status = ridehail?.status?.toLowerCase();
          return ridehail?.move?.cancel_status || status === "cancelled" || status === "canceled";
        });
      } else if (filters.metric === "completed") {
        filtered = filtered.filter((ridehail) => {
          const status = ridehail?.status?.toLowerCase();
          return status === "completed" || status === "droppedoff" || status === "dropped_off" || ridehail?.move?.status === "delivery successful";
        });
      } else if (filters.metric === "active") {
        filtered = filtered.filter((ridehail) => {
          const status = ridehail?.status?.toLowerCase();
          return (status === "pending" || status === "booking" || status === "booked" || status === "driver_assigned" || status === "driver_arrived" || status === "in_progress") && !ridehail?.move?.cancel_status;
        });
      }
    }
    if (filters.searchText) {
      const searchLower = filters.searchText.toLowerCase();
      filtered = filtered.filter((ridehail) => {
        const move = ridehail?.move;
        const parentMove = move?.parentMove;
        const driver = move?.driver;
        const lane = move?.lane;
        return ridehail?.id?.toString().includes(searchLower) || ridehail?.provider?.toLowerCase().includes(searchLower) || ridehail?.driver_name?.toLowerCase().includes(searchLower) || ridehail?.pickup_address?.toLowerCase().includes(searchLower) || ridehail?.dropoff_address?.toLowerCase().includes(searchLower) || move?.id?.toString().includes(searchLower) || move?.parent_move_id?.toString().includes(searchLower) || move?.reference_num?.toLowerCase().includes(searchLower) || move?.vehicle_vin?.toLowerCase().includes(searchLower) || move?.vehicle_stock?.toLowerCase().includes(searchLower) || move?.consumer_name?.toLowerCase().includes(searchLower) || move?.consumer_email?.toLowerCase().includes(searchLower) || move?.consumer_phone?.includes(searchLower) || parentMove?.consumer_name?.toLowerCase().includes(searchLower) || parentMove?.reference_num?.toLowerCase().includes(searchLower) || parentMove?.vehicle_vin?.toLowerCase().includes(searchLower) || driver?.user?.display_name?.toLowerCase().includes(searchLower) || lane?.pickup?.name?.toLowerCase().includes(searchLower) || lane?.delivery?.name?.toLowerCase().includes(searchLower) || lane?.description?.toLowerCase().includes(searchLower) || lane?.pickup?.address?.toLowerCase().includes(searchLower) || lane?.delivery?.address?.toLowerCase().includes(searchLower);
      });
    }
    if (filters.provider) {
      filtered = filtered.filter(
        (ridehail) => ridehail?.provider?.toLowerCase().includes(filters.provider.toLowerCase())
      );
    }
    if (filters.status) {
      filtered = filtered.filter((ridehail) => {
        const status = ridehail?.status?.toLowerCase();
        const filterStatus = filters.status.toLowerCase();
        if (filterStatus === "canceled") {
          return ridehail?.move?.cancel_status || status === "cancelled" || status === "canceled" || status === "failed" || status === "retry";
        }
        if (filterStatus === "completed") {
          return status === "completed" || status === "droppedoff" || status === "dropped_off" || ridehail?.move?.status === "delivery successful";
        }
        if (filterStatus === "active") {
          return (status === "pending" || status === "booking" || status === "booked" || status === "driver_assigned" || status === "driver_arrived" || status === "in_progress") && !ridehail?.move?.cancel_status;
        }
        return status === filterStatus;
      });
    }
    return filtered;
  }, [data, filters]);
  const contextValue = {
    data,
    loading,
    filters,
    filteredData,
    setData,
    setLoading,
    updateFilters
  };
  return /* @__PURE__ */ jsx2(RidehailsContext.Provider, { value: contextValue, children });
};
var useRidehails = () => {
  const context = useContext(RidehailsContext);
  if (context === void 0) {
    throw new Error("useRidehails must be used within a RidehailsProvider");
  }
  return context;
};
var isPickupWithinLastDay = (pickupTime) => {
  if (!pickupTime) return false;
  const oneDayAgo = dayjs().subtract(1, "day");
  const pickup = dayjs(pickupTime);
  return pickup.isAfter(oneDayAgo);
};
var formatTime = (time) => {
  if (time && typeof time === "string") {
    let newTime = dayjs(time).format("M/D/YYYY h:mm A z");
    newTime = newTime.replace(/\s/g, "\xA0");
    return newTime;
  }
  return null;
};
var capitalizeWords = (text) => {
  if (!text) return "";
  return text.replace(/[_-]/g, " ").split(" ").map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(" ");
};
var formatStatus = (status) => {
  if (!status) return "Pending";
  if (status.toLowerCase() === "droppedoff") {
    return "Completed";
  }
  const formattedStatus = status.replace(/_/g, " ");
  return capitalizeWords(formattedStatus);
};
var getStatusColor = (ridehail) => {
  const status = ridehail?.status?.toLowerCase();
  const moveStatus = ridehail?.move?.status;
  const cancelStatus = ridehail?.move?.cancel_status;
  const pickupTime = ridehail?.pickup_time || ridehail?.pickup_at || ridehail?.move?.ready_by;
  if (cancelStatus) return "error";
  if (status === "completed" || status === "droppedoff" || moveStatus === "delivery successful") return "success";
  if (status === "in_progress" || status === "active") return "warning";
  if (status === "scheduled" || status === "pending") return "info";
  if (status === "failed" || status === "canceled") return "error";
  if (!status && pickupTime && isPickupWithinLastDay(pickupTime)) return "info";
  return "default";
};
var getStatusIcon = (ridehail) => {
  const status = ridehail?.status?.toLowerCase();
  const cancelStatus = ridehail?.move?.cancel_status;
  if (cancelStatus) return /* @__PURE__ */ jsx2(BiSolidXCircle, {});
  if (status === "completed" || status === "droppedoff") return /* @__PURE__ */ jsx2(BiSolidCheckCircle, {});
  if (status === "in_progress" || status === "active") return /* @__PURE__ */ jsx2(BiTime, {});
  return void 0;
};
var getPriceRange = (ridehail) => {
  if (!ridehail) return null;
  const actualPrice = Math.ceil(ridehail.actual_price || 0);
  const priceRange = actualPrice && actualPrice > 0 ? [actualPrice, actualPrice + 5] : null;
  return priceRange ? priceRange.map((price) => `$${price}`).join(" - ") : "-";
};
var getProviderChip = (provider) => {
  const lowerProvider = provider?.toLowerCase() || "";
  if (lowerProvider.includes("uber")) {
    return /* @__PURE__ */ jsx2(
      Chip,
      {
        variant: "filled",
        sx: {
          backgroundColor: "#000000",
          "& .MuiChip-label": {
            padding: "6px 8px",
            display: "flex",
            alignItems: "center"
          },
          "& img": {
            filter: "invert(1) drop-shadow(0 0 0.5px white) drop-shadow(0 0 0.5px white)"
          }
        },
        label: /* @__PURE__ */ jsx2("img", { src: uberLogo, alt: "Uber", style: { width: 24, height: 24 } })
      }
    );
  }
  if (lowerProvider.includes("lyft")) {
    return /* @__PURE__ */ jsx2(
      Chip,
      {
        variant: "filled",
        sx: {
          backgroundColor: "#FF00BF",
          "& .MuiChip-label": {
            padding: "6px 8px",
            display: "flex",
            alignItems: "center"
          },
          "& img": {
            filter: "invert(1)"
          }
        },
        label: /* @__PURE__ */ jsx2("img", { src: lyftLogo, alt: "Lyft", style: { width: 24, height: 24 } })
      }
    );
  }
  return "-";
};

// src/components/RidehailsBoard.tsx
import React4 from "react";

// src/lib/csv.ts
import dayjs2 from "dayjs";
import { toast } from "react-toastify";
import { ExportToCsv } from "export-to-csv";
var generateRidehailsCSV = (ridehails, start, end) => {
  if (ridehails && ridehails.length > 0) {
    try {
      const createCsvRow = (ridehail) => {
        const move = ridehail?.move;
        const parentMove = move?.parentMove;
        const driver = move?.driver;
        const lane = move?.lane;
        const pickupTime = ridehail?.pickup_time || move?.ready_by;
        const hasStatus = ridehail?.status || move?.status;
        let displayStatus;
        if (move?.cancel_status) {
          displayStatus = `Canceled: ${move?.cancel_reason || "Unknown"}`;
        } else if ((!hasStatus || hasStatus.toLowerCase() === "not called") && pickupTime && isPickupWithinLastDay(pickupTime)) {
          displayStatus = "Pending";
        } else {
          const status = hasStatus || "";
          if (status.toLowerCase() === "droppedoff") {
            displayStatus = "Completed";
          } else {
            displayStatus = status.replace(/_/g, " ").split(" ").map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(" ");
          }
        }
        const laneText = lane?.pickup?.name && lane?.delivery?.name ? `${lane.pickup.name} to ${lane.delivery.name}` : lane?.description || ridehail?.pickup_address || "";
        const distance = ridehail?.distance_miles || lane?.distance_miles || "";
        const actualPrice = Math.ceil(ridehail?.actual_price || 0);
        const priceRange = actualPrice && actualPrice > 0 ? `$${actualPrice} - $${actualPrice + 5}` : "";
        return {
          drive_id: move?.parent_move_id || "",
          consumer: parentMove?.consumer_name || "",
          reference_num: parentMove?.reference_num || "",
          vin: parentMove?.vehicle_vin || "",
          provider: ridehail?.provider || "",
          status: displayStatus,
          driver: driver?.user?.display_name || "",
          planned_time: pickupTime ? formatTime(pickupTime) : "",
          lane: laneText,
          distance_miles: distance,
          price: priceRange
        };
      };
      const csvRows = ridehails.map((ridehail) => createCsvRow(ridehail));
      const csvOptions = {
        filename: `rideshares_${dayjs2(start).format("MM-DD-YYYY")}_to_${dayjs2(end).format("MM-DD-YYYY")}`,
        useKeysAsHeaders: true
      };
      const csvExporter = new ExportToCsv(csvOptions);
      csvExporter.generateCsv(csvRows);
      toast.success("Generated CSV!", { autoClose: 2e3, toastId: "csv-generated" });
    } catch (err) {
      toast.error("Failed to generate CSV!");
      console.error("Failed to generate CSV:", err);
    }
  } else {
    toast.error("Failed to generate CSV - No rideshares found!");
    console.error("Failed to generate CSV - No rideshares found!");
  }
};

// src/components/RidehailsBoard.tsx
import dayjs4 from "dayjs";
import {
  Box as Box2,
  Card,
  CardContent,
  LinearProgress
} from "@mui/material";

// src/components/RidehailsTable.tsx
import { Chip as Chip2, Typography } from "@mui/material";
import { BiFingerprint } from "react-icons/bi";

// src/internal/SimpleTable.tsx
import React3 from "react";
import { Link } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Tooltip
} from "@mui/material";
import { Fragment, jsx as jsx3, jsxs } from "react/jsx-runtime";
var compareValues = (a, b) => {
  if (a == null && b == null) return 0;
  if (a == null) return -1;
  if (b == null) return 1;
  if (typeof a === "number" && typeof b === "number") return a - b;
  return String(a).localeCompare(String(b));
};
var SimpleTable = ({
  rows,
  columns,
  rowKey,
  defaultOrderBy: defaultOrderBy2,
  defaultOrder: defaultOrder2 = "desc",
  rowHref,
  stickyHeader = true,
  ariaLabel,
  rowsPerPageOptions = [10, 25, 50, 100],
  defaultRowsPerPage = 25
}) => {
  const [orderBy, setOrderBy] = React3.useState(defaultOrderBy2);
  const [order, setOrder] = React3.useState(defaultOrder2);
  const [page, setPage] = React3.useState(0);
  const [rowsPerPage, setRowsPerPage] = React3.useState(defaultRowsPerPage);
  React3.useEffect(() => {
    setPage(0);
  }, [rows.length]);
  const sorted = React3.useMemo(() => {
    const column = columns.find((c) => c.name === orderBy);
    if (!column) return rows;
    const factor = order === "asc" ? 1 : -1;
    return [...rows].sort((a, b) => compareValues(column.value(a), column.value(b)) * factor);
  }, [rows, columns, orderBy, order]);
  const pageRows = sorted.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  const onSort = (name) => {
    if (name === orderBy) setOrder((current) => current === "asc" ? "desc" : "asc");
    else {
      setOrderBy(name);
      setOrder("asc");
    }
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx3(TableContainer, { sx: { overflowX: "auto" }, children: /* @__PURE__ */ jsxs(Table, { size: "small", stickyHeader, "aria-label": ariaLabel, children: [
      /* @__PURE__ */ jsx3(TableHead, { children: /* @__PURE__ */ jsx3(TableRow, { children: columns.map((column) => {
        const header = /* @__PURE__ */ jsx3(
          TableSortLabel,
          {
            active: orderBy === column.name,
            direction: orderBy === column.name ? order : "asc",
            onClick: () => onSort(column.name),
            children: column.label
          }
        );
        return /* @__PURE__ */ jsx3(
          TableCell,
          {
            align: column.align ?? "left",
            style: column.style,
            sortDirection: orderBy === column.name ? order : false,
            children: column.tooltip ? /* @__PURE__ */ jsx3(Tooltip, { title: column.tooltip, placement: "top", children: header }) : header
          },
          column.name
        );
      }) }) }),
      /* @__PURE__ */ jsx3(TableBody, { children: pageRows.map((row) => {
        const href = rowHref ? rowHref(row) : void 0;
        return /* @__PURE__ */ jsx3(
          TableRow,
          {
            hover: !!href,
            component: href ? Link : "tr",
            to: href,
            sx: href ? { textDecoration: "none", color: "inherit", cursor: "pointer" } : void 0,
            children: columns.map((column) => /* @__PURE__ */ jsx3(TableCell, { align: column.align ?? "left", style: column.style, children: column.renderer ? column.renderer(row) : String(column.value(row) ?? "-") }, column.name))
          },
          rowKey(row)
        );
      }) })
    ] }) }),
    /* @__PURE__ */ jsx3(
      TablePagination,
      {
        component: "div",
        count: rows.length,
        page,
        onPageChange: (_event, newPage) => setPage(newPage),
        rowsPerPage,
        onRowsPerPageChange: (event) => {
          setRowsPerPage(parseInt(event.target.value, 10));
          setPage(0);
        },
        rowsPerPageOptions
      }
    )
  ] });
};
var SimpleTable_default = SimpleTable;

// src/components/RidehailsTable.tsx
import { Fragment as Fragment2, jsx as jsx4, jsxs as jsxs2 } from "react/jsx-runtime";
var defaultOrder = `desc`;
var defaultOrderBy = `pickup_time`;
var RidehailsTable = ({ ridehails }) => {
  const host = useRidehailsHost();
  const refLabel = host.referenceNumLabel || "Reference ID";
  const columns = [
    {
      name: "drive_id",
      label: "Drive ID",
      tooltip: `HopDrive's internal drive move ID (parent move)`,
      value: (ridehail) => ridehail?.move?.parent_move_id,
      renderer: (ridehail) => /* @__PURE__ */ jsx4(Chip2, { color: "utility", label: ridehail?.move?.parent_move_id || "-", icon: /* @__PURE__ */ jsx4(BiFingerprint, { size: 14 }) }),
      style: { minWidth: 104 }
    },
    {
      name: "consumer_name",
      label: "Consumer",
      value: (ridehail) => ridehail?.move?.parentMove?.consumer_name || "-",
      renderer: (ridehail) => /* @__PURE__ */ jsx4(Typography, { variant: "body2", children: ridehail?.move?.parentMove?.consumer_name || "-" }),
      style: { minWidth: 140 }
    },
    {
      name: "reference_num",
      label: refLabel,
      tooltip: `Your internal reference ID - Currently configured as ${refLabel}.`,
      value: (ridehail) => ridehail?.move?.parentMove?.reference_num || "-",
      renderer: (ridehail) => /* @__PURE__ */ jsx4(Typography, { variant: "body2", children: ridehail?.move?.parentMove?.reference_num || "-" }),
      style: { minWidth: 120 }
    },
    {
      name: "vin",
      label: "VIN",
      value: (ridehail) => ridehail?.move?.parentMove?.vehicle_vin || "-",
      renderer: (ridehail) => /* @__PURE__ */ jsx4(Typography, { variant: "body2", children: ridehail?.move?.parentMove?.vehicle_vin || "-" }),
      style: { minWidth: 160 }
    },
    {
      name: "provider",
      label: "Provider",
      value: (ridehail) => ridehail?.provider,
      renderer: (ridehail) => getProviderChip(ridehail?.provider),
      style: { minWidth: 120 }
    },
    {
      name: "status",
      label: "Status",
      value: (ridehail) => ridehail?.status || ridehail?.move?.status,
      renderer: (ridehail) => {
        const pickupTime = ridehail?.pickup_time || ridehail?.move?.ready_by;
        const hasStatus = ridehail?.status || ridehail?.move?.status;
        let displayStatus;
        if (ridehail?.move?.cancel_status) {
          displayStatus = `Canceled: ${ridehail?.move?.cancel_reason || "Unknown"}`;
        } else if ((!hasStatus || hasStatus.toLowerCase() === "not called") && pickupTime && isPickupWithinLastDay(pickupTime)) {
          displayStatus = "Pending";
        } else {
          displayStatus = formatStatus(hasStatus || "");
        }
        return /* @__PURE__ */ jsx4(Chip2, { color: getStatusColor(ridehail), label: displayStatus, icon: getStatusIcon(ridehail) });
      },
      style: { minWidth: 160 }
    },
    {
      name: "driver",
      label: "Driver",
      value: (ridehail) => {
        const driver = ridehail?.move?.driver;
        if (!driver) return "-";
        return `${driver.user.display_name}`;
      },
      renderer: (ridehail) => {
        const driver = ridehail?.move?.driver;
        if (!driver) return "-";
        return /* @__PURE__ */ jsx4("div", { children: /* @__PURE__ */ jsx4(Typography, { variant: "body2", children: driver.user.display_name }) });
      },
      style: { minWidth: 160 }
    },
    {
      name: "pickup_time",
      label: "Planned Time",
      value: (ridehail) => ridehail?.pickup_time || ridehail?.move?.ready_by,
      renderer: (ridehail) => formatTime(ridehail?.pickup_time || ridehail?.move?.ready_by || "") || "-",
      style: { minWidth: 144 }
    },
    {
      name: "lane",
      label: "Lane",
      value: (ridehail) => {
        const lane = ridehail?.move?.lane;
        if (!lane) return ridehail?.pickup_address || "-";
        return lane?.pickup?.name && lane?.delivery?.name ? `${lane.pickup.name} to ${lane.delivery.name}` : lane?.description || "-";
      },
      renderer: (ridehail) => {
        const lane = ridehail?.move?.lane;
        if (!lane) {
          return /* @__PURE__ */ jsxs2("div", { children: [
            /* @__PURE__ */ jsx4(Typography, { variant: "body2", children: ridehail?.pickup_address || "-" }),
            ridehail?.delivery_address && /* @__PURE__ */ jsxs2(Typography, { variant: "body2", children: [
              "to ",
              ridehail?.delivery_address
            ] })
          ] });
        }
        return /* @__PURE__ */ jsx4("div", { children: lane?.pickup?.name && lane?.delivery?.name ? /* @__PURE__ */ jsxs2(Fragment2, { children: [
          /* @__PURE__ */ jsx4(Typography, { variant: "body2", children: lane.pickup.name }),
          /* @__PURE__ */ jsxs2(Typography, { variant: "body2", children: [
            "to ",
            lane.delivery.name
          ] })
        ] }) : /* @__PURE__ */ jsx4(Typography, { variant: "body2", children: lane?.description || "-" }) });
      },
      style: { minWidth: 240 }
    },
    {
      name: "distance",
      label: "Distance",
      value: (ridehail) => ridehail?.distance_miles || ridehail?.move?.lane?.distance_miles || 0,
      renderer: (ridehail) => {
        const distance = ridehail?.distance_miles || ridehail?.move?.lane?.distance_miles;
        return distance ? `${distance} mi` : "-";
      },
      style: { minWidth: 96 },
      align: "right"
    },
    {
      name: "actual_fare",
      label: "Price",
      value: (ridehail) => getPriceRange(ridehail),
      renderer: (ridehail) => getPriceRange(ridehail),
      style: { minWidth: 112 },
      align: "right"
    }
  ];
  return /* @__PURE__ */ jsx4(
    SimpleTable_default,
    {
      rows: ridehails,
      columns,
      rowKey: (row) => `${row?.move_id ?? row?.id}`,
      defaultOrderBy,
      defaultOrder,
      ariaLabel: "ridehails",
      stickyHeader: true,
      defaultRowsPerPage: 50,
      rowHref: (row) => host.ridehailHref(row?.move_id)
    }
  );
};
var RidehailsTable_default = RidehailsTable;

// src/components/RidehailsControls.tsx
import dayjs3 from "dayjs";
import { css as css2 } from "@emotion/css";
import { TextField, InputAdornment, Icon, MenuItem, Divider, useTheme as useTheme2 } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";

// src/internal/Spacer.tsx
import { useTheme } from "@mui/material/styles";
import { css } from "@emotion/css";
import { jsx as jsx5 } from "react/jsx-runtime";
var sizeMapping = {
  xxxs: 0.25,
  xxs: 0.5,
  xs: 1,
  sm: 1.5,
  md: 2,
  lg: 3,
  xl: 4,
  xxl: 6,
  xxxl: 8
};
var getSize = (size) => {
  if (typeof size === "string") {
    const parsedSize = parseFloat(size);
    if (!isNaN(parsedSize)) {
      return parsedSize;
    }
    return sizeMapping[size] || 2;
  }
  return size || 2;
};
var useStyles = (theme, size) => ({
  spacerH: css`
    display: 'block';
    width: '100%';
    height: ${theme.spacing(size)};
  `,
  spacerV: css`
    display: 'inline-block';
    width: ${theme.spacing(size)};
  `
});
var Spacer = ({ column, size }) => {
  const theme = useTheme();
  const styles = useStyles(theme, getSize(size));
  return /* @__PURE__ */ jsx5("div", { className: column ? styles.spacerV : styles.spacerH });
};
var Spacer_default = Spacer;

// src/components/RidehailsControls.tsx
import { Fragment as Fragment3, jsx as jsx6, jsxs as jsxs3 } from "react/jsx-runtime";
var RidehailsControls = ({
  range,
  start,
  end,
  disablePickers,
  provider,
  search,
  providersPool,
  setProvider,
  setSearch,
  onRangeChange,
  onDateChange,
  trailing
}) => {
  const theme = useTheme2();
  const cls = useStyles2(theme);
  return /* @__PURE__ */ jsxs3(Fragment3, { children: [
    /* @__PURE__ */ jsxs3("div", { className: cls.controls, children: [
      /* @__PURE__ */ jsxs3(
        TextField,
        {
          select: true,
          fullWidth: true,
          label: "Date Range",
          placeholder: "Select a date range...",
          variant: "outlined",
          size: "small",
          value: range,
          onChange: (e) => onRangeChange?.(e.target.value),
          children: [
            /* @__PURE__ */ jsxs3(MenuItem, { value: "tomorrow", children: [
              /* @__PURE__ */ jsx6("span", { className: cls.rangeText, children: "Tomorrow" }),
              /* @__PURE__ */ jsx6("span", { className: cls.rangeSubText, children: dayjs3().add(1, "day").format("MM/DD/YYYY") })
            ] }),
            /* @__PURE__ */ jsxs3(MenuItem, { value: "today", children: [
              /* @__PURE__ */ jsx6("span", { className: cls.rangeText, children: "Today" }),
              /* @__PURE__ */ jsx6("span", { className: cls.rangeSubText, children: dayjs3().format("MM/DD/YYYY") })
            ] }),
            /* @__PURE__ */ jsxs3(MenuItem, { value: "yesterday", children: [
              /* @__PURE__ */ jsx6("span", { className: cls.rangeText, children: "Yesterday" }),
              /* @__PURE__ */ jsx6("span", { className: cls.rangeSubText, children: dayjs3().subtract(1, "day").format("MM/DD/YYYY") })
            ] }),
            /* @__PURE__ */ jsx6(Divider, {}),
            /* @__PURE__ */ jsxs3(MenuItem, { value: "nextweek", children: [
              /* @__PURE__ */ jsx6("span", { className: cls.rangeText, children: "Next Week" }),
              /* @__PURE__ */ jsxs3("span", { className: cls.rangeSubText, children: [
                dayjs3().add(1, "week").startOf("week").format("MM/DD/YYYY"),
                " -",
                " ",
                dayjs3().add(1, "week").endOf("week").format("MM/DD/YYYY")
              ] })
            ] }),
            /* @__PURE__ */ jsxs3(MenuItem, { value: "thisweek", children: [
              /* @__PURE__ */ jsx6("span", { className: cls.rangeText, children: "This Week" }),
              /* @__PURE__ */ jsxs3("span", { className: cls.rangeSubText, children: [
                dayjs3().startOf("week").format("MM/DD/YYYY"),
                " - ",
                dayjs3().endOf("week").format("MM/DD/YYYY")
              ] })
            ] }),
            /* @__PURE__ */ jsxs3(MenuItem, { value: "lastweek", children: [
              /* @__PURE__ */ jsx6("span", { className: cls.rangeText, children: "Last Week" }),
              /* @__PURE__ */ jsxs3("span", { className: cls.rangeSubText, children: [
                dayjs3().subtract(1, "week").startOf("week").format("MM/DD/YYYY"),
                " -",
                " ",
                dayjs3().subtract(1, "week").endOf("week").format("MM/DD/YYYY")
              ] })
            ] }),
            /* @__PURE__ */ jsx6(Divider, {}),
            /* @__PURE__ */ jsxs3(MenuItem, { value: "nextmonth", children: [
              /* @__PURE__ */ jsx6("span", { className: cls.rangeText, children: "Next Month" }),
              /* @__PURE__ */ jsxs3("span", { className: cls.rangeSubText, children: [
                dayjs3().add(1, "month").startOf("month").format("MM/DD/YYYY"),
                " -",
                " ",
                dayjs3().add(1, "month").endOf("month").format("MM/DD/YYYY")
              ] })
            ] }),
            /* @__PURE__ */ jsxs3(MenuItem, { value: "thismonth", children: [
              /* @__PURE__ */ jsx6("span", { className: cls.rangeText, children: "This Month" }),
              /* @__PURE__ */ jsxs3("span", { className: cls.rangeSubText, children: [
                dayjs3().startOf("month").format("MM/DD/YYYY"),
                " - ",
                dayjs3().endOf("month").format("MM/DD/YYYY")
              ] })
            ] }),
            /* @__PURE__ */ jsxs3(MenuItem, { value: "lastmonth", children: [
              /* @__PURE__ */ jsx6("span", { className: cls.rangeText, children: "Last Month" }),
              /* @__PURE__ */ jsxs3("span", { className: cls.rangeSubText, children: [
                dayjs3().subtract(1, "month").startOf("month").format("MM/DD/YYYY"),
                " -",
                " ",
                dayjs3().subtract(1, "month").endOf("month").format("MM/DD/YYYY")
              ] })
            ] }),
            /* @__PURE__ */ jsx6(Divider, {}),
            /* @__PURE__ */ jsx6(MenuItem, { value: "custom", children: "Custom" })
          ]
        }
      ),
      /* @__PURE__ */ jsx6(
        DatePicker,
        {
          disabled: disablePickers,
          maxDate: dayjs3(end),
          label: "Start Date",
          orientation: "portrait",
          value: dayjs3(start),
          onChange: (date) => onDateChange?.("start")(date?.toString() || ""),
          slotProps: {
            textField: {
              fullWidth: true,
              size: "small",
              variant: "outlined"
            }
          }
        }
      ),
      /* @__PURE__ */ jsx6(
        DatePicker,
        {
          disabled: disablePickers,
          minDate: dayjs3(start),
          label: "End Date",
          orientation: "portrait",
          value: dayjs3(end),
          onChange: (date) => onDateChange?.("end")(date?.toString() || ""),
          slotProps: {
            textField: {
              fullWidth: true,
              size: "small",
              variant: "outlined"
            }
          }
        }
      )
    ] }),
    /* @__PURE__ */ jsx6(Spacer_default, { size: 1.5 }),
    /* @__PURE__ */ jsxs3("div", { className: cls.controls, children: [
      /* @__PURE__ */ jsxs3(
        TextField,
        {
          select: true,
          fullWidth: true,
          label: "Provider",
          variant: "outlined",
          size: "small",
          value: provider,
          onChange: (e) => setProvider?.(e.target.value),
          children: [
            /* @__PURE__ */ jsx6(MenuItem, { value: "", children: "All Providers" }),
            providersPool.map((prov) => /* @__PURE__ */ jsx6(MenuItem, { value: prov, children: prov.replace("_", " ").split(" ").map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ") }, prov))
          ]
        }
      ),
      /* @__PURE__ */ jsx6(
        TextField,
        {
          fullWidth: true,
          label: "Search",
          placeholder: "Search rideshares...",
          variant: "outlined",
          size: "small",
          value: search || "",
          onChange: (e) => setSearch?.(e.target.value),
          slotProps: {
            input: {
              startAdornment: /* @__PURE__ */ jsx6(InputAdornment, { position: "start", children: /* @__PURE__ */ jsx6(Icon, { color: "disabled", fontSize: "small", children: "search" }) })
            }
          }
        }
      ),
      trailing
    ] })
  ] });
};
var useStyles2 = (theme) => ({
  controls: css2`
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
  `,
  rangeText: css2`
    margin-right: 6px;
  `,
  rangeSubText: css2`
    font-size: 12px;
    color: ${theme.palette.text.disabled};
  `
});
var RidehailsControls_default = RidehailsControls;

// src/components/RidehailsMetrics.tsx
import { css as css3 } from "@emotion/css";
import { Typography as Typography2, useTheme as useTheme3 } from "@mui/material";
import {
  BiSolidCar,
  BiSolidCheckCircle as BiSolidCheckCircle2,
  BiPlayCircle,
  BiSolidXCircle as BiSolidXCircle2,
  BiTaxi,
  BiTime as BiTime2,
  BiStopCircle
} from "react-icons/bi";
import { jsx as jsx7, jsxs as jsxs4 } from "react/jsx-runtime";
var RidehailsMetrics = ({ loading, counts, metric, onMetricChange }) => {
  const theme = useTheme3();
  const cls = useStyles3(theme);
  const clsx = useSxStyles(theme);
  const { allRides, activeRides, completedRides, failedRides, canceledRides, notCalledRides, pendingRides } = counts;
  const handleMetricClick = (selectedMetric) => {
    onMetricChange(selectedMetric);
  };
  return /* @__PURE__ */ jsxs4("div", { className: cls.metrics, children: [
    /* @__PURE__ */ jsx7(
      "div",
      {
        className: `${cls.metricCard} ${metric === "all" ? cls.metricCardAllActive : ""}`,
        onClick: () => handleMetricClick("all"),
        children: /* @__PURE__ */ jsxs4("div", { className: cls.metricContent, children: [
          /* @__PURE__ */ jsx7(BiSolidCar, { size: 40, color: theme.palette.utility.main }),
          /* @__PURE__ */ jsxs4("div", { children: [
            /* @__PURE__ */ jsx7(Typography2, { variant: "h3", sx: clsx.metricNumber, children: loading ? `-` : allRides }),
            /* @__PURE__ */ jsx7(Typography2, { variant: "body2", sx: clsx.metricLabel, children: "Total" })
          ] })
        ] })
      }
    ),
    /* @__PURE__ */ jsx7(
      "div",
      {
        className: `${cls.metricCard} ${metric === "pending" ? cls.metricCardPendingActive : ""}`,
        onClick: () => handleMetricClick("pending"),
        children: /* @__PURE__ */ jsxs4("div", { className: cls.metricContent, children: [
          /* @__PURE__ */ jsx7(BiTime2, { size: 40, color: theme.palette.info.main }),
          /* @__PURE__ */ jsxs4("div", { children: [
            /* @__PURE__ */ jsx7(Typography2, { variant: "h3", sx: clsx.metricNumber, children: loading ? `-` : pendingRides }),
            /* @__PURE__ */ jsx7(Typography2, { variant: "body2", sx: clsx.metricLabel, children: "Pending" })
          ] })
        ] })
      }
    ),
    /* @__PURE__ */ jsx7(
      "div",
      {
        className: `${cls.metricCard} ${metric === "active" ? cls.metricCardActiveActive : ""}`,
        onClick: () => handleMetricClick("active"),
        children: /* @__PURE__ */ jsxs4("div", { className: cls.metricContent, children: [
          /* @__PURE__ */ jsx7(BiPlayCircle, { size: 40, color: theme.palette.warning.main }),
          /* @__PURE__ */ jsxs4("div", { children: [
            /* @__PURE__ */ jsx7(Typography2, { variant: "h3", sx: clsx.metricNumber, children: loading ? `-` : activeRides }),
            /* @__PURE__ */ jsx7(Typography2, { variant: "body2", sx: clsx.metricLabel, children: "In Progress" })
          ] })
        ] })
      }
    ),
    /* @__PURE__ */ jsx7(
      "div",
      {
        className: `${cls.metricCard} ${metric === "completed" ? cls.metricCardCompletedActive : ""}`,
        onClick: () => handleMetricClick("completed"),
        children: /* @__PURE__ */ jsxs4("div", { className: cls.metricContent, children: [
          /* @__PURE__ */ jsx7(BiSolidCheckCircle2, { size: 40, color: theme.palette.success.main }),
          /* @__PURE__ */ jsxs4("div", { children: [
            /* @__PURE__ */ jsx7(Typography2, { variant: "h3", sx: clsx.metricNumber, children: loading ? `-` : completedRides }),
            /* @__PURE__ */ jsx7(Typography2, { variant: "body2", sx: clsx.metricLabel, children: "Completed" })
          ] })
        ] })
      }
    ),
    /* @__PURE__ */ jsx7(
      "div",
      {
        className: `${cls.metricCard} ${metric === "canceled" ? cls.metricCardCanceledActive : ""}`,
        onClick: () => handleMetricClick("canceled"),
        children: /* @__PURE__ */ jsxs4("div", { className: cls.metricContent, children: [
          /* @__PURE__ */ jsx7(BiStopCircle, { size: 40, color: theme.palette.error.main }),
          /* @__PURE__ */ jsxs4("div", { children: [
            /* @__PURE__ */ jsx7(Typography2, { variant: "h3", sx: clsx.metricNumber, children: loading ? `-` : canceledRides }),
            /* @__PURE__ */ jsx7(Typography2, { variant: "body2", sx: clsx.metricLabel, children: "Canceled" })
          ] })
        ] })
      }
    ),
    /* @__PURE__ */ jsx7(
      "div",
      {
        className: `${cls.metricCard} ${metric === "failed" ? cls.metricCardFailedActive : ""}`,
        onClick: () => handleMetricClick("failed"),
        children: /* @__PURE__ */ jsxs4("div", { className: cls.metricContent, children: [
          /* @__PURE__ */ jsx7(BiSolidXCircle2, { size: 40, color: theme.palette.error.main }),
          /* @__PURE__ */ jsxs4("div", { children: [
            /* @__PURE__ */ jsx7(Typography2, { variant: "h3", sx: clsx.metricNumber, children: loading ? `-` : failedRides }),
            /* @__PURE__ */ jsx7(Typography2, { variant: "body2", sx: clsx.metricLabel, children: "Failed" })
          ] })
        ] })
      }
    ),
    /* @__PURE__ */ jsx7(
      "div",
      {
        className: `${cls.metricCard} ${metric === "not_called" ? cls.metricCardNotCalledActive : ""}`,
        onClick: () => handleMetricClick("not_called"),
        children: /* @__PURE__ */ jsxs4("div", { className: cls.metricContent, children: [
          /* @__PURE__ */ jsx7(BiTaxi, { size: 40, color: theme.palette.text.secondary }),
          /* @__PURE__ */ jsxs4("div", { children: [
            /* @__PURE__ */ jsx7(Typography2, { variant: "h3", sx: clsx.metricNumber, children: loading ? `-` : notCalledRides }),
            /* @__PURE__ */ jsx7(Typography2, { variant: "body2", sx: clsx.metricLabel, children: "Inactive" })
          ] })
        ] })
      }
    )
  ] });
};
var useStyles3 = (theme) => ({
  metrics: css3`
    display: flex;
    gap: 16px;
  `,
  metricCard: css3`
    padding: 24px;
    border: 1px solid ${theme.palette.divider};
    border-radius: 10px;
    outline: 2px solid transparent;
    outline-offset: -2px;
    background-color: ${theme.palette.background.default};
    cursor: pointer;
    transition: all 0.15s ease-in-out;

    &:hover {
      background-color: ${theme.palette.background.alt};
    }
  `,
  metricCardAllActive: css3`
    outline-color: ${theme.palette.utility.main};
    background-color: ${theme.palette.utility.main}20;
    &:hover {
      background-color: ${theme.palette.utility.main}30;
    }
  `,
  metricCardPendingActive: css3`
    outline-color: ${theme.palette.info.main};
    background-color: ${theme.palette.info.main}20;
    &:hover {
      background-color: ${theme.palette.info.main}30;
    }
  `,
  metricCardNotCalledActive: css3`
    outline-color: ${theme.palette.text.secondary};
    background-color: ${theme.palette.action.hover};
    &:hover {
      background-color: ${theme.palette.action.selected};
    }
  `,
  metricCardActiveActive: css3`
    outline-color: ${theme.palette.warning.main};
    background-color: ${theme.palette.warning.main}20;
    &:hover {
      background-color: ${theme.palette.warning.main}30;
    }
  `,
  metricCardCompletedActive: css3`
    outline-color: ${theme.palette.success.main};
    background-color: ${theme.palette.success.main}20;
    &:hover {
      background-color: ${theme.palette.success.main}30;
    }
  `,
  metricCardFailedActive: css3`
    outline-color: ${theme.palette.error.main};
    background-color: ${theme.palette.error.main}20;
    &:hover {
      background-color: ${theme.palette.error.main}30;
    }
  `,
  metricCardCanceledActive: css3`
    outline-color: ${theme.palette.error.main};
    background-color: ${theme.palette.error.main}20;
    &:hover {
      background-color: ${theme.palette.error.main}30;
    }
  `,
  metricContent: css3`
    display: flex;
    align-items: center;
    gap: 16px;
  `
});
var useSxStyles = (theme) => ({
  metricNumber: {
    lineHeight: 1,
    fontWeight: 600,
    color: theme.palette.text.primary
  },
  metricLabel: {
    lineHeight: 1,
    marginTop: `4px`,
    color: theme.palette.text.secondary
  }
});
var RidehailsMetrics_default = RidehailsMetrics;

// src/internal/Loading.tsx
import { Box, CircularProgress, Typography as Typography3 } from "@mui/material";
import { jsx as jsx8, jsxs as jsxs5 } from "react/jsx-runtime";
var Loading = ({ message }) => /* @__PURE__ */ jsxs5(
  Box,
  {
    sx: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: 2,
      py: 8
    },
    children: [
      /* @__PURE__ */ jsx8(CircularProgress, {}),
      message ? /* @__PURE__ */ jsx8(Typography3, { variant: "body2", color: "text.secondary", children: message }) : null
    ]
  }
);
var Loading_default = Loading;

// src/internal/DefaultFallback.tsx
import { Alert, AlertTitle, useTheme as useTheme4 } from "@mui/material";
import { jsx as jsx9 } from "react/jsx-runtime";
var DefaultFallback = ({ message, fullscreen = false, severity = "info" }) => {
  const theme = useTheme4();
  if (fullscreen)
    return /* @__PURE__ */ jsx9(
      Alert,
      {
        severity: severity || void 0,
        sx: {
          borderTop: `1px solid ${severity ? theme?.palette?.[severity]?.main : theme?.palette?.utility?.main}`,
          borderBottom: `1px solid ${severity ? theme?.palette?.[severity]?.main : theme?.palette?.utility?.main}`,
          borderRadius: 0
        },
        children: /* @__PURE__ */ jsx9(AlertTitle, { children: message || `No data found.` })
      }
    );
  return /* @__PURE__ */ jsx9(
    Alert,
    {
      severity,
      sx: { border: `1px solid ${severity ? theme?.palette?.[severity]?.main : theme?.palette?.utility?.main}` },
      children: /* @__PURE__ */ jsx9(AlertTitle, { children: message || `No data found.` })
    }
  );
};
var DefaultFallback_default = DefaultFallback;

// src/components/RidehailsBoard.tsx
import { css as css4 } from "@emotion/css";
import { jsx as jsx10, jsxs as jsxs6 } from "react/jsx-runtime";
var RidehailsBoard = ({ renderToolbar }) => {
  const cls = useStyles4();
  const { loading, data, filteredData, filters, updateFilters } = useRidehails();
  const [disablePickers, setDisablePickers] = React4.useState(filters.range !== "custom");
  const counts = React4.useMemo(() => {
    let dateFiltered = [...data];
    if (filters.fromDate || filters.toDate) {
      const fromDate = filters.fromDate ? dayjs4(filters.fromDate) : null;
      const toDate = filters.toDate ? dayjs4(filters.toDate) : null;
      dateFiltered = dateFiltered.filter((ridehail) => {
        const dateStr = ridehail?.created_at || ridehail?.move?.ready_by;
        if (!dateStr) return false;
        const date = dayjs4(dateStr);
        if (fromDate && date.isBefore(fromDate)) return false;
        if (toDate && date.isAfter(toDate)) return false;
        return true;
      });
    }
    const allRides = dateFiltered.length;
    const allNotCalled = dateFiltered.filter((r) => r?.status === "Not Called");
    const pendingRides = allNotCalled.filter((r) => {
      const pickupTime = r?.pickup_at || r?.move?.ready_by;
      return pickupTime && isPickupWithinLastDay(pickupTime);
    }).length;
    const notCalledRides = allNotCalled.filter((r) => {
      const pickupTime = r?.pickup_at || r?.move?.ready_by;
      return !pickupTime || !isPickupWithinLastDay(pickupTime);
    }).length;
    const completedRides = dateFiltered.filter((r) => {
      const status = r?.status?.toLowerCase();
      return status === "completed" || status === "droppedoff" || status === "dropped_off" || r?.move?.status === "delivery successful";
    }).length;
    const activeRides = dateFiltered.filter((r) => {
      const status = r?.status?.toLowerCase();
      return (status === "pending" || status === "booking" || status === "booked" || status === "driver_assigned" || status === "driver_arrived" || status === "in_progress") && !r?.move?.cancel_status;
    }).length;
    const failedRides = dateFiltered.filter((r) => {
      const status = r?.status?.toLowerCase();
      return status === "failed" || status === "retry";
    }).length;
    const canceledRides = dateFiltered.filter((r) => {
      const status = r?.status?.toLowerCase();
      return r?.move?.cancel_status || status === "cancelled" || status === "canceled";
    }).length;
    return {
      allRides,
      pendingRides,
      notCalledRides,
      activeRides,
      completedRides,
      failedRides,
      canceledRides
    };
  }, [data, filters.fromDate, filters.toDate]);
  const providersPool = React4.useMemo(() => {
    return [...new Set(data.map((r) => r?.provider).filter((prov) => Boolean(prov)))];
  }, [data]);
  const handleRangeChange = (range) => {
    let start = dayjs4().startOf("day").toISOString();
    let end = dayjs4().endOf("day").toISOString();
    switch (range) {
      case "tomorrow":
        start = dayjs4().add(1, "day").startOf("day").toISOString();
        end = dayjs4().add(1, "day").endOf("day").toISOString();
        break;
      case "today":
        start = dayjs4().startOf("day").toISOString();
        end = dayjs4().endOf("day").toISOString();
        break;
      case "yesterday":
        start = dayjs4().subtract(1, "day").startOf("day").toISOString();
        end = dayjs4().subtract(1, "day").endOf("day").toISOString();
        break;
      case "nextweek":
        start = dayjs4().add(1, "week").startOf("week").toISOString();
        end = dayjs4().add(1, "week").endOf("week").toISOString();
        break;
      case "thisweek":
        start = dayjs4().startOf("week").toISOString();
        end = dayjs4().endOf("week").toISOString();
        break;
      case "lastweek":
        start = dayjs4().subtract(1, "week").startOf("week").toISOString();
        end = dayjs4().subtract(1, "week").endOf("week").toISOString();
        break;
      case "nextmonth":
        start = dayjs4().add(1, "month").startOf("month").toISOString();
        end = dayjs4().add(1, "month").endOf("month").toISOString();
        break;
      case "thismonth":
        start = dayjs4().startOf("month").toISOString();
        end = dayjs4().endOf("month").toISOString();
        break;
      case "lastmonth":
        start = dayjs4().subtract(1, "month").startOf("month").toISOString();
        end = dayjs4().subtract(1, "month").endOf("month").toISOString();
        break;
      case "custom":
        setDisablePickers(false);
        updateFilters({ range });
        return;
      default:
        break;
    }
    setDisablePickers(range !== "custom");
    updateFilters({
      range,
      fromDate: start,
      toDate: end
    });
  };
  const handleDateChange = (type) => (date) => {
    if (date) {
      if (type === "start") {
        updateFilters({ fromDate: dayjs4(date).startOf("day").toISOString() });
      } else {
        updateFilters({ toDate: dayjs4(date).endOf("day").toISOString() });
      }
    }
  };
  const handleMetricChange = (newMetric) => {
    updateFilters({ metric: newMetric });
  };
  const handleClearFilters = () => {
    handleRangeChange("thisweek");
    updateFilters({
      searchText: "",
      provider: "",
      metric: "all"
    });
  };
  if (loading) {
    return /* @__PURE__ */ jsx10(Loading_default, { message: "Loading rideshare data..." });
  }
  return /* @__PURE__ */ jsxs6(Box2, { className: cls.container, children: [
    renderToolbar?.({
      clearFilters: handleClearFilters,
      exportCsv: () => generateRidehailsCSV(filteredData, filters.fromDate, filters.toDate),
      csvDisabled: filteredData.length === 0
    }),
    loading && /* @__PURE__ */ jsx10(LinearProgress, {}),
    /* @__PURE__ */ jsx10(Spacer_default, { size: 2 }),
    /* @__PURE__ */ jsx10(
      RidehailsControls_default,
      {
        range: filters.range,
        start: filters.fromDate,
        end: filters.toDate,
        disablePickers,
        provider: filters.provider,
        search: filters.searchText,
        providersPool,
        setProvider: (provider) => updateFilters({ provider }),
        setSearch: (search) => updateFilters({ searchText: search }),
        onRangeChange: handleRangeChange,
        onDateChange: handleDateChange
      }
    ),
    /* @__PURE__ */ jsx10(Spacer_default, { size: 2 }),
    /* @__PURE__ */ jsx10(
      RidehailsMetrics_default,
      {
        loading,
        counts,
        metric: filters.metric,
        onMetricChange: handleMetricChange
      }
    ),
    /* @__PURE__ */ jsx10(Spacer_default, { size: 2 }),
    filteredData.length === 0 ? /* @__PURE__ */ jsx10(
      DefaultFallback_default,
      {
        fullscreen: true,
        severity: "warning",
        message: "No rideshares found with selected filters."
      }
    ) : /* @__PURE__ */ jsx10(Card, { children: /* @__PURE__ */ jsx10(CardContent, { sx: { p: 0 }, children: /* @__PURE__ */ jsx10(RidehailsTable_default, { ridehails: filteredData }) }) })
  ] });
};
var useStyles4 = () => ({
  container: css4`
    padding: 24px;
    height: 100%;
    overflow-y: auto;
  `
});
var RidehailsBoard_default = RidehailsBoard;

// src/components/RidehailsBoardData.tsx
import React5 from "react";
import dayjs5 from "dayjs";

// src/lib/rows.ts
var toRidehailRows = (moves) => moves.map((move) => {
  const ridehail = move.ridehails?.[0];
  return {
    // If ridehail exists, use its data; otherwise create a "not called" entry
    id: ridehail?.id || null,
    move_id: move.id,
    driver_name: ridehail?.driver_name || null,
    provider: ridehail?.provider || null,
    status: ridehail?.status || "Not Called",
    external_id: ridehail?.external_id || null,
    pickup_address: ridehail?.pickup_address || null,
    dropoff_address: ridehail?.dropoff_address || null,
    pickup_at: ridehail?.pickup_at || null,
    dropoff_at: ridehail?.dropoff_at || null,
    pickup_lat: ridehail?.pickup_lat || null,
    pickup_lng: ridehail?.pickup_lng || null,
    dropoff_lat: ridehail?.dropoff_lat || null,
    dropoff_lng: ridehail?.dropoff_lng || null,
    estimated_price: ridehail?.estimated_price || null,
    actual_price: ridehail?.actual_price || null,
    // Map to the field name expected by the table
    actual_fare: ridehail?.actual_price || null,
    created_at: ridehail?.created_at || move.pickup_time || null,
    updated_at: ridehail?.updated_at || move.pickup_time || null,
    // Include the move data
    move: {
      id: move.id,
      parent_move_id: move.parent_move_id,
      reference_num: move.reference_num,
      vehicle_vin: move.vehicle_vin,
      vehicle_stock: move.vehicle_stock,
      vehicle_year: move.vehicle_year,
      vehicle_make: move.vehicle_make,
      vehicle_model: move.vehicle_model,
      vehicle_color: move.vehicle_color,
      ready_by: move.pickup_time,
      status: move.status,
      cancel_status: move.cancel_status,
      cancel_reason: move.cancel_reason,
      consumer_type: move.consumer_type,
      consumer_name: move.consumer_name,
      consumer_email: move.consumer_email,
      consumer_phone: move.consumer_phone,
      consumer_pickup: move.consumer_pickup,
      customer: move.customer,
      lane: move.lane,
      driver: move.driver,
      parentMove: move.parentMove
    }
  };
});

// src/components/RidehailsBoardData.tsx
import { Fragment as Fragment4, jsx as jsx11 } from "react/jsx-runtime";
var RidehailsBoardData = ({
  customerId,
  useRidehailsQuery,
  renderToolbar,
  renderError
}) => {
  const { setData, setLoading } = useRidehails();
  const ninetyDaysAgo = dayjs5().subtract(90, "days").startOf("day").toISOString();
  const tomorrow = dayjs5().add(1, "day").endOf("day").toISOString();
  const { data, loading, error, refetch } = useRidehailsQuery({
    variables: {
      customer_id: customerId,
      from_date: ninetyDaysAgo,
      to_date: tomorrow,
      limit: 1e3
    },
    fetchPolicy: "cache-and-network",
    notifyOnNetworkStatusChange: true,
    skip: !customerId
  });
  React5.useEffect(() => {
    setLoading(loading);
  }, [loading, setLoading]);
  React5.useEffect(() => {
    if (data?.moves) {
      setData(toRidehailRows(data.moves));
    }
  }, [data, setData]);
  if (error) {
    return /* @__PURE__ */ jsx11(Fragment4, { children: renderError(error.message) });
  }
  return /* @__PURE__ */ jsx11(RidehailsBoard_default, { renderToolbar: (toolbar) => renderToolbar(toolbar, refetch) });
};
var RidehailsBoardData_default = RidehailsBoardData;

// src/components/RidehailActions.tsx
import { useState as useState2 } from "react";
import axios from "axios";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert as Alert2,
  CircularProgress as CircularProgress2,
  Box as Box3,
  Typography as Typography4
} from "@mui/material";
import { BiPhone, BiX } from "react-icons/bi";
import { toast as toast2 } from "react-toastify";
import dayjs6 from "dayjs";
import { Fragment as Fragment5, jsx as jsx12, jsxs as jsxs7 } from "react/jsx-runtime";
var RidehailActions = ({ move, ridehail, onRefetch }) => {
  const host = useRidehailsHost();
  const [openDialog, setOpenDialog] = useState2(false);
  const [loading, setLoading] = useState2(false);
  const handleCallRide = async () => {
    setLoading(true);
    try {
      const token = await host.getAccessToken();
      const endpoint = host.devProxyOrigin ? `${host.devProxyOrigin}/.netlify/functions/app-call-ride` : `${host.ridesBaseUrl}/v1/app-call-ride`;
      const response = await axios({
        method: "POST",
        url: endpoint,
        data: {
          moveId: move.id
        },
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        }
      });
      if (response?.data?.success === true) {
        toast2.success("Ride called successfully! Awaiting response...");
        setOpenDialog(false);
        onRefetch();
      } else {
        console.error("Failed to book ride:", response.data);
        toast2.error("Failed to book ride");
      }
    } catch (error) {
      console.error("Error calling ride:", error);
      toast2.error("Failed to book ride");
    } finally {
      setLoading(false);
    }
  };
  const handleCancelRide = async () => {
    if (!ridehail?.id) {
      toast2.error("Cannot cancel ride: missing ride ID");
      return;
    }
    setLoading(true);
    try {
      const token = await host.getAccessToken();
      const endpoint = "/v1/app-cancel-ride";
      const baseUrl = host.ridesBaseUrl;
      const response = await axios({
        method: "POST",
        url: `${baseUrl}${endpoint}`,
        data: {
          // The rides API keys off the internal ridehails.id, not the
          // provider's external_id (which 400s with "Missing ridehailId").
          ridehailId: ridehail.id
        },
        headers: {
          "Authorization": `Bearer ${token}`
        }
      });
      if (response?.data?.success === true) {
        toast2.success("Ride canceled successfully");
        setOpenDialog(false);
        onRefetch();
      } else {
        console.error("Failed to cancel ride:", response?.data);
        toast2.error("Failed to cancel ride");
      }
    } catch (error) {
      console.error("Error canceling ride:", error);
      toast2.error("Failed to cancel ride");
    } finally {
      setLoading(false);
    }
  };
  const isPickupTooOld = () => {
    const pickupTime = move.pickup_time;
    if (!pickupTime) return false;
    const oneDayAgo = dayjs6().subtract(1, "day");
    const pickup = dayjs6(pickupTime);
    return pickup.isBefore(oneDayAgo);
  };
  const hasValidCoordinates = move.lane?.pickup?.latitude && move.lane?.pickup?.longitude && move.lane?.delivery?.latitude && move.lane?.delivery?.longitude;
  const hasReadyDriver = () => {
    const rideStatus = move.driver_status?.toLowerCase();
    const parentStatus = move.parentMove?.driver_status?.toLowerCase();
    return rideStatus === "accepted" || rideStatus === "assigned" || parentStatus === "accepted" || parentStatus === "assigned";
  };
  const status = ridehail?.status;
  const canCancelRide = ridehail && ridehail.external_id && (status === "booked" || // Successfully booked, awaiting driver
  status === "driver_assigned" || // Driver assigned and enroute
  status === "driver_arrived");
  const canCallRide = !ridehail || (status === "cancelled" || status === "failed");
  if (ridehail && (status === "in_progress" || // Ride is active
  status === "completed")) {
    return null;
  }
  if (!canCallRide && !canCancelRide || host.readOnly || host.actionsEnabled === false) {
    return null;
  }
  return /* @__PURE__ */ jsxs7(Fragment5, { children: [
    /* @__PURE__ */ jsx12(
      Button,
      {
        variant: "contained",
        size: "small",
        startIcon: canCallRide ? /* @__PURE__ */ jsx12(BiPhone, {}) : /* @__PURE__ */ jsx12(BiX, {}),
        color: canCallRide ? "primary" : "error",
        onClick: () => setOpenDialog(true),
        children: canCallRide ? "Book Ride" : "Cancel Ride"
      }
    ),
    /* @__PURE__ */ jsxs7(Dialog, { open: openDialog, onClose: () => setOpenDialog(false), maxWidth: "sm", fullWidth: true, children: [
      /* @__PURE__ */ jsx12(DialogTitle, { children: canCallRide ? "Book Ride" : "Cancel Ride" }),
      /* @__PURE__ */ jsx12(DialogContent, { children: /* @__PURE__ */ jsx12(Box3, { sx: { pt: 1 }, children: canCallRide ? /* @__PURE__ */ jsxs7(Fragment5, { children: [
        !hasValidCoordinates && /* @__PURE__ */ jsx12(Alert2, { severity: "error", sx: { mb: 2 }, children: "Missing location coordinates. Cannot call a ridehail without valid pickup and dropoff coordinates." }),
        isPickupTooOld() && /* @__PURE__ */ jsx12(Alert2, { severity: "warning", sx: { mb: 2 }, children: "Pickup time is more than 24 hours in the past. Cannot book a ridehail." }),
        !hasReadyDriver() && /* @__PURE__ */ jsx12(Alert2, { severity: "error", sx: { mb: 2 }, children: "A driver must be assigned to this ride (or its parent drive move) before booking a ridehail." }),
        hasValidCoordinates && !isPickupTooOld() && hasReadyDriver() && /* @__PURE__ */ jsxs7(Alert2, { severity: "info", sx: { mb: 2 }, children: [
          "This will hail a ride for Move #",
          move.id
        ] }),
        /* @__PURE__ */ jsxs7(Box3, { children: [
          /* @__PURE__ */ jsxs7(Typography4, { variant: "body2", color: "text.secondary", gutterBottom: true, children: [
            /* @__PURE__ */ jsx12("strong", { children: "Pickup:" }),
            " ",
            move.lane?.pickup?.address || "No address available",
            !move.lane?.pickup?.latitude && " (missing coordinates)"
          ] }),
          /* @__PURE__ */ jsxs7(Typography4, { variant: "body2", color: "text.secondary", children: [
            /* @__PURE__ */ jsx12("strong", { children: "Dropoff:" }),
            " ",
            move.lane?.delivery?.address || "No address available",
            !move.lane?.delivery?.latitude && " (missing coordinates)"
          ] })
        ] })
      ] }) : /* @__PURE__ */ jsx12(Alert2, { severity: "warning", children: "Are you sure you want to cancel this rideshare? This action cannot be undone, and may result in a cancellation fee." }) }) }),
      /* @__PURE__ */ jsxs7(DialogActions, { children: [
        /* @__PURE__ */ jsx12(Button, { onClick: () => setOpenDialog(false), disabled: loading, color: "secondary", children: "Close" }),
        canCallRide ? /* @__PURE__ */ jsx12(
          Button,
          {
            variant: "contained",
            color: "primary",
            onClick: handleCallRide,
            disabled: loading || !hasValidCoordinates || isPickupTooOld() || !hasReadyDriver(),
            startIcon: loading ? /* @__PURE__ */ jsx12(CircularProgress2, { size: 16 }) : /* @__PURE__ */ jsx12(BiPhone, {}),
            children: "Book Ride"
          }
        ) : /* @__PURE__ */ jsx12(
          Button,
          {
            variant: "contained",
            color: "error",
            onClick: handleCancelRide,
            disabled: loading,
            startIcon: loading ? /* @__PURE__ */ jsx12(CircularProgress2, { size: 16 }) : /* @__PURE__ */ jsx12(BiX, {}),
            children: "Cancel Ride"
          }
        )
      ] })
    ] })
  ] });
};
var RidehailActions_default = RidehailActions;

// src/components/RidehailDetailsView.tsx
import React13 from "react";
import { useNavigate } from "react-router-dom";
import { css as css11 } from "@emotion/css";
import { Container, Paper, Typography as Typography6, Button as Button3, Chip as Chip3, Alert as Alert4, useTheme as useTheme12 } from "@mui/material";

// src/internal/InfoItem.tsx
import { css as css5 } from "@emotion/css";
import { useTheme as useTheme5, Typography as Typography5 } from "@mui/material";
import { jsx as jsx13, jsxs as jsxs8 } from "react/jsx-runtime";
var InfoItem = ({ size, keyText, valueText, valueTransform }) => {
  const theme = useTheme5();
  const cls = useStyles5(theme);
  const getFontSize = () => {
    switch (size) {
      case `sm`:
        return `12px`;
      case `md`:
        return `14px`;
      case `lg`:
        return `16px`;
      default:
        return `14px`;
    }
  };
  const getLineMargin = () => {
    switch (size) {
      case `sm`:
        return `7px 0`;
      case `md`:
        return `9px 0`;
      case `lg`:
        return `11px 0`;
      default:
        return `9px 0`;
    }
  };
  return /* @__PURE__ */ jsxs8("div", { className: cls.infoItem, children: [
    keyText ? /* @__PURE__ */ jsx13(
      Typography5,
      {
        variant: "body2",
        sx: { whiteSpace: `nowrap`, fontSize: getFontSize(), color: theme?.palette?.text?.disabled },
        children: keyText
      }
    ) : null,
    keyText || valueText ? /* @__PURE__ */ jsx13("div", { className: cls.infoItemLine, style: { margin: getLineMargin() } }) : /* @__PURE__ */ jsx13(Typography5, { variant: "body2", sx: { visibility: `hidden`, whiteSpace: `nowrap`, fontSize: getFontSize() }, children: "..." }),
    valueText ? /* @__PURE__ */ jsx13(Typography5, { variant: "body2", sx: { fontSize: getFontSize(), textTransform: valueTransform || `none` }, children: valueText }) : null
  ] });
};
var useStyles5 = (theme) => ({
  infoItem: css5`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 6px;
    word-break: break-word;
  `,
  infoItemLine: css5`
    flex: 1;
    border-top: 1px dashed ${theme?.palette?.action?.focus};
  `
});
var InfoItem_default = InfoItem;

// src/components/RidehailDetailsMap.tsx
import { Button as Button2, useTheme as useTheme11, Alert as Alert3 } from "@mui/material";
import { Map } from "@vis.gl/react-google-maps";
import { css as css10 } from "@emotion/css";

// src/internal/maps/LocationPinMarker.tsx
import React8 from "react";
import { useTheme as useTheme6 } from "@mui/material";

// src/internal/maps/HtmlMapMarker.tsx
import React7 from "react";
import { createPortal } from "react-dom";
import { useMap } from "@vis.gl/react-google-maps";
var HtmlOverlayClass = null;
function getHtmlOverlayClass() {
  if (HtmlOverlayClass) return HtmlOverlayClass;
  HtmlOverlayClass = class extends google.maps.OverlayView {
    constructor(position, zIndex) {
      super();
      this.position = new google.maps.LatLng(position);
      this.zIndex = zIndex;
      this.container = document.createElement("div");
      this.container.style.position = "absolute";
      this.container.style.transform = "translate(-50%, -50%)";
      this.container.style.zIndex = String(zIndex);
      this.container.style.cursor = "pointer";
    }
    getContainer() {
      return this.container;
    }
    updatePosition(position) {
      this.position = new google.maps.LatLng(position);
      this.draw();
    }
    updateZIndex(zIndex) {
      this.zIndex = zIndex;
      this.container.style.zIndex = String(zIndex);
    }
    onAdd() {
      const panes = this.getPanes();
      panes?.overlayMouseTarget?.appendChild(this.container);
    }
    draw() {
      const projection = this.getProjection();
      if (!projection) return;
      const point = projection.fromLatLngToDivPixel(this.position);
      if (!point) return;
      this.container.style.left = `${point.x}px`;
      this.container.style.top = `${point.y}px`;
    }
    onRemove() {
      this.container.remove();
    }
  };
  return HtmlOverlayClass;
}
var HtmlMapMarker = ({ mapId, position, zIndex = 1, children }) => {
  const map = useMap(mapId);
  const overlayRef = React7.useRef(null);
  const [container, setContainer] = React7.useState(null);
  React7.useEffect(() => {
    if (!map || position.lat == null || position.lng == null) return;
    const OverlayClass = getHtmlOverlayClass();
    const overlay = new OverlayClass(position, zIndex);
    overlay.setMap(map);
    overlayRef.current = overlay;
    setContainer(overlay.getContainer());
    return () => {
      overlay.setMap(null);
      overlayRef.current = null;
      setContainer(null);
    };
  }, [map]);
  React7.useEffect(() => {
    if (overlayRef.current && position.lat != null && position.lng != null) {
      overlayRef.current.updatePosition(position);
    }
  }, [position.lat, position.lng]);
  React7.useEffect(() => {
    if (overlayRef.current) {
      overlayRef.current.updateZIndex(zIndex);
    }
  }, [zIndex]);
  if (position.lat == null || position.lng == null || !container) return null;
  return createPortal(children, container);
};
var HtmlMapMarker_default = HtmlMapMarker;

// src/internal/maps/PinMarker.tsx
import { css as css6 } from "@emotion/css";
import { jsx as jsx14, jsxs as jsxs9 } from "react/jsx-runtime";
var PinMarker = ({
  backgroundColor,
  foregroundColor,
  icon,
  size = 36,
  hintText,
  hoverBrighter,
  onClick,
  children
}) => {
  const cls = useStyles6({ size, hoverBrighter });
  const foregroundSize = size - 4;
  return /* @__PURE__ */ jsxs9("div", { onClick, children: [
    /* @__PURE__ */ jsxs9("div", { className: cls.pin, title: hintText, children: [
      /* @__PURE__ */ jsx14(
        "svg",
        {
          className: cls.pinBackground,
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 160 220",
          style: { width: size, height: size },
          children: /* @__PURE__ */ jsx14(
            "path",
            {
              fill: backgroundColor,
              d: "M80,220c-13.23,0-18.13-12.14-20.48-17.98-.42-1.04-.82-2.02-1.16-2.75l-.1-.21c-3.43-7.72-6.62-14.31-11.04-21.35-4.5-7.22-9.65-13.9-15.11-20.97-5.63-7.31-11.46-14.86-16.53-23.08C5.25,116.95,0,98.89,0,80,0,35.89,35.89,0,80,0s80,35.89,80,80c0,18.97-5.29,37.04-15.72,53.71-5.11,8.34-11.04,16.03-16.77,23.46-5.36,6.95-10.42,13.52-14.83,20.55-4.38,6.98-7.48,13.56-11.08,21.44-.31,.69-.68,1.62-1.07,2.62-2.33,5.92-7.17,18.23-20.53,18.23Z"
            }
          )
        }
      ),
      /* @__PURE__ */ jsx14(
        "svg",
        {
          className: cls.pinForeground,
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 140 200",
          style: { width: foregroundSize, height: foregroundSize },
          children: /* @__PURE__ */ jsx14(
            "path",
            {
              fill: foregroundColor,
              d: "M70,0C31.3,0,0,31.3,0,70c0,17.4,5,33.7,14.1,48.4,9.5,15.4,22,28.6,31.6,44,4.7,7.5,8.1,14.5,11.7,22.6,2.6,5.5,4.7,15,12.6,15s10-9.5,12.5-15c3.7-8.1,7-15.1,11.7-22.6,9.6-15.3,22.1-28.5,31.6-44,9.2-14.7,14.2-31,14.2-48.4C140,31.3,108.7,0,70,0Zm0,0"
            }
          )
        }
      ),
      icon ? /* @__PURE__ */ jsx14("div", { className: cls.pinIcon, children: icon }) : null
    ] }),
    children
  ] });
};
var useStyles6 = ({ size, hoverBrighter }) => ({
  pin: css6`
    position: relative;
    cursor: pointer;
    transition:
      transform 0.2s ease-in-out,
      filter 0.2s ease-in-out;

    &:hover {
      transform: scale(1.1);
      ${hoverBrighter ? "filter: brightness(1.2);" : ""}
    }
  `,
  pinBackground: css6`
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  `,
  pinForeground: css6`
    position: absolute;
    bottom: 2px;
    left: 50%;
    transform: translateX(-50%);
  `,
  pinIcon: css6`
    position: absolute;
    bottom: ${Math.round(size * 0.33)}px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
  `
});
var PinMarker_default = PinMarker;

// src/internal/maps/markerTheme.ts
import { BiSolidHeart, BiSolidMapPin, BiSolidUserCircle } from "react-icons/bi";
import { MdPlayCircle, MdFlagCircle } from "react-icons/md";
var FALLBACK_MAIN = "#a0a4b0";
var FALLBACK_ALT = "#404860";
var getMarkerPaletteKey = (markerId) => {
  if (markerId === "pickup") return "info";
  if (markerId === "delivery") return "success";
  if (markerId === "driver") return "primary";
  return "utility";
};
var getMarkerIcon = (markerId) => {
  if (markerId === "pickup") return MdPlayCircle;
  if (markerId === "delivery") return MdFlagCircle;
  if (markerId === "driver") return BiSolidUserCircle;
  if (markerId === "favorite") return BiSolidHeart;
  return BiSolidMapPin;
};
var resolveThemeColor = (theme, paletteKey, shade) => {
  if (paletteKey === "utility") {
    if (shade === "alt") return theme?.palette?.utility?.main || FALLBACK_ALT;
    return theme?.palette?.utility?.lighter || FALLBACK_MAIN;
  }
  const slot = theme?.palette?.[paletteKey];
  if (shade === "alt") return slot?.darker || FALLBACK_ALT;
  return slot?.main || FALLBACK_MAIN;
};
var getMarkerBackgroundColor = (theme, markerId) => resolveThemeColor(theme, getMarkerPaletteKey(markerId), "main");
var getMarkerForegroundColor = (theme, markerId) => resolveThemeColor(theme, getMarkerPaletteKey(markerId), "alt");

// src/internal/maps/LocationPinMarker.tsx
import { jsx as jsx15 } from "react/jsx-runtime";
var LocationPinBubbleVisibilityContext = React8.createContext(true);
var LocationPinMarker = ({
  mapId,
  markerId,
  position,
  size = 36,
  iconSize = 20,
  hintText,
  hoverBrighter,
  zIndex,
  onClick,
  bubbleTrigger = "hover",
  bubbleOpen,
  rotation,
  children
}) => {
  const theme = useTheme6();
  const [isHovered, setIsHovered] = React8.useState(false);
  const IconComponent = getMarkerIcon(markerId);
  const backgroundColor = getMarkerBackgroundColor(theme, markerId);
  const foregroundColor = getMarkerForegroundColor(theme, markerId);
  const shouldShowBubble = bubbleTrigger === "always" ? true : bubbleTrigger === "selected" ? !!bubbleOpen : isHovered;
  const effectiveZIndex = shouldShowBubble ? Math.max(zIndex ?? 1, 999) : zIndex;
  return /* @__PURE__ */ jsx15(HtmlMapMarker_default, { mapId: mapId ?? "", position, zIndex: effectiveZIndex, children: /* @__PURE__ */ jsx15("div", { onMouseEnter: () => setIsHovered(true), onMouseLeave: () => setIsHovered(false), children: /* @__PURE__ */ jsx15(
    PinMarker_default,
    {
      backgroundColor,
      foregroundColor,
      size,
      hintText,
      hoverBrighter,
      onClick,
      icon: /* @__PURE__ */ jsx15(
        "div",
        {
          style: {
            display: "inline-flex",
            transform: rotation != null ? `rotate(${rotation}deg)` : void 0,
            transformOrigin: "center"
          },
          children: /* @__PURE__ */ jsx15(IconComponent, { size: iconSize, style: { color: backgroundColor } })
        }
      ),
      children: /* @__PURE__ */ jsx15(LocationPinBubbleVisibilityContext.Provider, { value: shouldShowBubble, children })
    }
  ) }) });
};
var LocationPinMarker_default = LocationPinMarker;

// src/internal/maps/MapControls.tsx
import React10 from "react";
import { css as css8 } from "@emotion/css";
import { useTheme as useTheme8, Tooltip as Tooltip2 } from "@mui/material";
import { BiSolidMoon, BiSolidSun } from "react-icons/bi";
import { MdFullscreen, MdFullscreenExit, MdVisibility, MdVisibilityOff } from "react-icons/md";

// src/internal/maps/GoogleMapsElement.tsx
import React9 from "react";
import { css as css7, cx } from "@emotion/css";

// src/internal/maps/useMapSurfaceColors.ts
import { useTheme as useTheme7 } from "@mui/material";

// src/internal/maps/useMapPreferences.ts
import { useMemo } from "react";

// src/internal/maps/googleMapStyles.ts
var lightMapStyles = [
  // Hide click clutter
  {
    featureType: "administrative.neighborhood",
    elementType: "labels",
    stylers: [{ visibility: "off" }]
  },
  {
    featureType: "poi",
    elementType: "labels",
    stylers: [{ visibility: "off" }]
  },
  {
    featureType: "administrative.land_parcel",
    stylers: [{ visibility: "off" }]
  },
  // Highway shields (route numbers, interstate badges) — visible
  {
    featureType: "road.highway",
    elementType: "labels.icon",
    stylers: [{ visibility: "on" }]
  },
  {
    featureType: "road.highway.controlled_access",
    elementType: "labels.icon",
    stylers: [{ visibility: "on" }]
  },
  // Base landscape — light neutral canvas
  {
    featureType: "landscape",
    elementType: "geometry",
    stylers: [{ color: "#f4f6f8" }]
  },
  {
    elementType: "labels.text.fill",
    stylers: [{ color: "#5a5a5a" }]
  },
  {
    elementType: "labels.text.stroke",
    stylers: [{ color: "#ffffff" }]
  },
  // Natural terrain / vegetation — soft green tint
  {
    featureType: "landscape.natural.terrain",
    elementType: "geometry",
    stylers: [{ color: "#c5dcc5" }]
  },
  {
    featureType: "landscape.natural.landcover",
    elementType: "geometry",
    stylers: [{ color: "#d4ead4" }]
  },
  // Water — soft blue-teal
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [{ color: "#b0cdd5" }]
  },
  {
    featureType: "water",
    elementType: "labels.text.fill",
    stylers: [{ color: "#ffffff" }]
  },
  // Parks, nature reserves, attractions, sports complexes — pale green
  {
    featureType: "poi.park",
    elementType: "geometry",
    stylers: [{ color: "#d8ecd8" }]
  },
  {
    featureType: "poi.attraction",
    elementType: "geometry",
    stylers: [{ color: "#d8ecd8" }]
  },
  {
    featureType: "poi.sports_complex",
    elementType: "geometry",
    stylers: [{ color: "#d8ecd8" }]
  },
  // Administrative — subdued labels
  {
    featureType: "administrative.country",
    elementType: "labels.text.fill",
    stylers: [{ color: "#777777" }]
  },
  {
    featureType: "administrative.locality",
    elementType: "labels.text.fill",
    stylers: [{ color: "#555555" }]
  },
  // Roads — light fills
  {
    featureType: "road",
    elementType: "geometry.fill",
    stylers: [{ color: "#ffffff" }]
  },
  {
    featureType: "road",
    elementType: "labels.text.fill",
    stylers: [{ color: "#5a5a5a" }]
  },
  {
    featureType: "road.arterial",
    elementType: "geometry",
    stylers: [{ color: "#f5f5f5" }]
  },
  {
    featureType: "road.highway",
    elementType: "geometry",
    stylers: [{ color: "#ebebeb" }]
  },
  {
    featureType: "road.highway.controlled_access",
    elementType: "geometry",
    stylers: [{ color: "#dcdcdc" }]
  },
  {
    featureType: "road.local",
    elementType: "labels.text.fill",
    stylers: [{ color: "#808080" }]
  },
  // Transit
  {
    featureType: "transit",
    elementType: "labels.text.fill",
    stylers: [{ color: "#5a5a5a" }]
  }
];
var darkMapStyles = [
  // Remove click clutter
  {
    featureType: "administrative.neighborhood",
    elementType: "labels",
    stylers: [{ visibility: "off" }]
  },
  {
    featureType: "poi",
    elementType: "labels",
    stylers: [{ visibility: "off" }]
  },
  {
    featureType: "administrative.land_parcel",
    stylers: [{ visibility: "off" }]
  },
  // Highway shields (route numbers, interstate badges) — visible
  {
    featureType: "road.highway",
    elementType: "labels.icon",
    stylers: [{ visibility: "on" }]
  },
  {
    featureType: "road.highway.controlled_access",
    elementType: "labels.icon",
    stylers: [{ visibility: "on" }]
  },
  // Base
  {
    elementType: "geometry",
    stylers: [{ color: "#161616" }]
  },
  {
    elementType: "labels.text.fill",
    stylers: [{ color: "#8a8a8a" }]
  },
  {
    elementType: "labels.text.stroke",
    stylers: [{ color: "#161616" }]
  },
  // Administrative
  {
    featureType: "administrative",
    elementType: "geometry",
    stylers: [{ color: "#757575" }]
  },
  {
    featureType: "administrative.country",
    elementType: "labels.text.fill",
    stylers: [{ color: "#9e9e9e" }]
  },
  {
    featureType: "administrative.locality",
    elementType: "labels.text.fill",
    stylers: [{ color: "#bdbdbd" }]
  },
  // POI
  {
    featureType: "poi",
    elementType: "labels.text.fill",
    stylers: [{ color: "#757575" }]
  },
  {
    featureType: "poi.park",
    elementType: "geometry",
    stylers: [{ color: "#080808" }]
  },
  {
    featureType: "poi.park",
    elementType: "labels.text.fill",
    stylers: [{ color: "#616161" }]
  },
  {
    featureType: "poi.park",
    elementType: "labels.text.stroke",
    stylers: [{ color: "#1b1b1b" }]
  },
  // Roads — fills
  {
    featureType: "road",
    elementType: "geometry.fill",
    stylers: [{ color: "#2c2c2c" }]
  },
  {
    featureType: "road",
    elementType: "labels.text.fill",
    stylers: [{ color: "#8a8a8a" }]
  },
  {
    featureType: "road.arterial",
    elementType: "geometry",
    stylers: [{ color: "#373737" }]
  },
  {
    featureType: "road.highway",
    elementType: "geometry",
    stylers: [{ color: "#3c3c3c" }]
  },
  {
    featureType: "road.highway.controlled_access",
    elementType: "geometry",
    stylers: [{ color: "#4e4e4e" }]
  },
  {
    featureType: "road.local",
    elementType: "labels.text.fill",
    stylers: [{ color: "#616161" }]
  },
  // Transit
  {
    featureType: "transit",
    elementType: "labels.text.fill",
    stylers: [{ color: "#757575" }]
  },
  // Water
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [{ color: "#080808" }]
  },
  {
    featureType: "water",
    elementType: "labels.text.fill",
    stylers: [{ color: "#555555" }]
  }
];
var lightSpotlightMapStyles = [
  // Spread light mode properties
  ...lightMapStyles,
  // Dim elements to make overlays more visible.
  {
    elementType: "labels.text.fill",
    stylers: [{ color: "#bbbbbb" }]
  },
  {
    elementType: "labels.text.stroke",
    stylers: [{ color: "#ffffff" }]
  },
  {
    featureType: "road",
    elementType: "geometry",
    stylers: [{ saturation: -100 }, { lightness: 50 }]
  },
  {
    featureType: "road",
    elementType: "labels.icon",
    stylers: [{ visibility: "on" }, { saturation: -100 }, { lightness: 75 }]
  },
  {
    featureType: "transit",
    elementType: "labels.icon",
    stylers: [{ visibility: "on" }, { saturation: -100 }, { lightness: 75 }]
  }
];
var darkSpotlightMapStyles = [
  // Spread dark mode properties
  ...darkMapStyles,
  // Dim elements to make overlays more visible.
  {
    elementType: "labels.text.fill",
    stylers: [{ color: "#555555" }]
  },
  {
    elementType: "labels.text.stroke",
    stylers: [{ color: "#161616" }]
  },
  {
    featureType: "road",
    elementType: "geometry",
    stylers: [{ saturation: -100 }, { lightness: -50 }]
  },
  {
    featureType: "road",
    elementType: "labels.icon",
    stylers: [{ visibility: "on" }, { saturation: -100 }, { lightness: -75 }]
  },
  {
    featureType: "transit",
    elementType: "labels.icon",
    stylers: [{ visibility: "on" }, { saturation: -100 }, { lightness: -75 }]
  }
];
var getMapStyles = (mode, spotlight) => {
  if (mode === "light") {
    return spotlight ? lightSpotlightMapStyles : lightMapStyles;
  }
  return spotlight ? darkSpotlightMapStyles : darkMapStyles;
};

// src/internal/maps/mapPreferences.ts
import { create } from "zustand";
var MODE_KEY = "map-preferences-mode";
var SPOTLIGHT_KEY = "map-preferences-spotlight";
var readInitialMode = () => {
  try {
    const stored = localStorage.getItem(MODE_KEY);
    if (stored === "light" || stored === "dark") return stored;
  } catch {
  }
  if (typeof window !== "undefined" && window.matchMedia) {
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
  }
  return "dark";
};
var readInitialSpotlight = () => {
  try {
    const stored = localStorage.getItem(SPOTLIGHT_KEY);
    if (stored === "true") return true;
    if (stored === "false") return false;
  } catch {
  }
  return false;
};
var useMapPreferencesStore = create(() => ({
  mode: readInitialMode(),
  spotlight: readInitialSpotlight()
}));
var setMapMode = (mode) => {
  useMapPreferencesStore.setState({ mode });
  try {
    localStorage.setItem(MODE_KEY, mode);
  } catch {
  }
};
var setMapSpotlight = (spotlight) => {
  useMapPreferencesStore.setState({ spotlight });
  try {
    localStorage.setItem(SPOTLIGHT_KEY, spotlight ? "true" : "false");
  } catch {
  }
};

// src/internal/maps/useMapPreferences.ts
var useMapPreferences = () => {
  const mode = useMapPreferencesStore((state) => state.mode);
  const spotlight = useMapPreferencesStore((state) => state.spotlight);
  const mapStyles = useMemo(() => getMapStyles(mode, spotlight), [mode, spotlight]);
  return {
    mode,
    spotlight,
    mapStyles,
    setMode: setMapMode,
    setSpotlight: setMapSpotlight
  };
};

// src/internal/maps/useMapSurfaceColors.ts
var useMapSurfaceColors = () => {
  const theme = useTheme7();
  const { mode } = useMapPreferences();
  const isLight = mode === "light";
  const panelBackground = isLight ? `${theme?.palette?.background?.paper}99` : `${theme?.palette?.utility?.main}60`;
  return {
    mode,
    isLight,
    primary: isLight ? theme?.palette?.text?.primary : theme?.palette?.text?.contrastPrimary,
    secondary: isLight ? theme?.palette?.text?.secondary : theme?.palette?.text?.contrastSecondary,
    disabled: isLight ? theme?.palette?.text?.disabled : theme?.palette?.text?.contrastDisabled,
    divider: isLight ? theme?.palette?.divider : theme?.palette?.dividerContrast,
    panelBackground
  };
};

// src/internal/maps/GoogleMapsElement.tsx
import { jsx as jsx16 } from "react/jsx-runtime";
var GoogleMapsElement = React9.forwardRef(
  ({ children, style, className, rounded, disablePadding, ...rest }, ref) => {
    const { panelBackground, divider } = useMapSurfaceColors();
    const cls = useStyles7({ rounded, disablePadding, panelBackground, border: divider });
    return /* @__PURE__ */ jsx16("div", { ref, className: cx(cls.element, className), style, ...rest, children });
  }
);
GoogleMapsElement.displayName = "GoogleMapsElement";
var useStyles7 = (props) => {
  return {
    element: css7`
      z-index: 1;
      position: absolute;
      background: ${props.panelBackground};
      padding: ${props?.disablePadding ? "0" : "8px"};
      border: 1px solid ${props.border};
      border-radius: ${props?.rounded ? "48px" : "8px"};
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.08);
      backdrop-filter: blur(6px);
    `
  };
};
var GoogleMapsElement_default = GoogleMapsElement;

// src/internal/maps/MapControls.tsx
import { jsx as jsx17, jsxs as jsxs10 } from "react/jsx-runtime";
var getFullscreenElement = () => {
  const doc = document;
  return doc.fullscreenElement ?? doc.webkitFullscreenElement ?? null;
};
var requestFullscreenOn = (el) => {
  const candidate = el;
  if (candidate.requestFullscreen) return candidate.requestFullscreen();
  if (candidate.webkitRequestFullscreen) return candidate.webkitRequestFullscreen();
};
var exitFullscreen = () => {
  const doc = document;
  if (doc.exitFullscreen) return doc.exitFullscreen();
  if (doc.webkitExitFullscreen) return doc.webkitExitFullscreen();
};
var MapControls = ({ style, className }) => {
  const theme = useTheme8();
  const { mode, spotlight, setMode, setSpotlight } = useMapPreferences();
  const cls = useStyles8(theme, mode);
  const wrapperRef = React10.useRef(null);
  const [isFullscreen, setIsFullscreen] = React10.useState(false);
  React10.useEffect(() => {
    const sync = () => {
      const container = wrapperRef.current?.parentElement ?? null;
      setIsFullscreen(!!container && getFullscreenElement() === container);
    };
    document.addEventListener("fullscreenchange", sync);
    document.addEventListener("webkitfullscreenchange", sync);
    sync();
    return () => {
      document.removeEventListener("fullscreenchange", sync);
      document.removeEventListener("webkitfullscreenchange", sync);
    };
  }, []);
  const handleFullscreen = () => {
    const container = wrapperRef.current?.parentElement;
    if (!container) return;
    if (getFullscreenElement() === container) {
      exitFullscreen();
    } else {
      requestFullscreenOn(container);
    }
  };
  const isDark = mode === "dark";
  const positionStyle = { top: 10, right: 10, ...style };
  return /* @__PURE__ */ jsx17(GoogleMapsElement_default, { ref: wrapperRef, style: positionStyle, className, disablePadding: true, children: /* @__PURE__ */ jsxs10("div", { className: cls.stack, children: [
    /* @__PURE__ */ jsx17(Tooltip2, { title: isFullscreen ? "Exit fullscreen" : "Enter fullscreen", placement: "left", children: /* @__PURE__ */ jsx17(
      "button",
      {
        type: "button",
        "aria-label": isFullscreen ? "Exit fullscreen" : "Enter fullscreen",
        "aria-pressed": isFullscreen,
        onClick: handleFullscreen,
        className: `${cls.btn} ${isFullscreen ? cls.btnActive : cls.btnInactive}`,
        children: isFullscreen ? /* @__PURE__ */ jsx17(MdFullscreenExit, { size: 20 }) : /* @__PURE__ */ jsx17(MdFullscreen, { size: 20 })
      }
    ) }),
    /* @__PURE__ */ jsx17(Tooltip2, { title: isDark ? "Switch to light mode" : "Switch to dark mode", placement: "left", children: /* @__PURE__ */ jsx17(
      "button",
      {
        type: "button",
        "aria-label": isDark ? "Switch to light mode" : "Switch to dark mode",
        "aria-pressed": isDark,
        onClick: () => setMode(isDark ? "light" : "dark"),
        className: `${cls.btn} ${isDark ? cls.btnActive : cls.btnInactive}`,
        children: isDark ? /* @__PURE__ */ jsx17(BiSolidMoon, { size: 18 }) : /* @__PURE__ */ jsx17(BiSolidSun, { size: 18 })
      }
    ) }),
    /* @__PURE__ */ jsx17(Tooltip2, { title: spotlight ? "Disable spotlight mode" : "Enable spotlight mode", placement: "left", children: /* @__PURE__ */ jsx17(
      "button",
      {
        type: "button",
        "aria-label": spotlight ? "Disable spotlight mode" : "Enable spotlight mode",
        "aria-pressed": spotlight,
        onClick: () => setSpotlight(!spotlight),
        className: `${cls.btn} ${spotlight ? cls.btnActive : cls.btnInactive}`,
        children: spotlight ? /* @__PURE__ */ jsx17(MdVisibility, { size: 18 }) : /* @__PURE__ */ jsx17(MdVisibilityOff, { size: 18 })
      }
    ) })
  ] }) });
};
var useStyles8 = (theme, mode) => {
  const primaryMain = theme?.palette?.primary?.main || "#1976d2";
  const primaryFaded = `${primaryMain}20`;
  const isLight = mode === "light";
  const inactiveFg = isLight ? theme?.palette?.text?.secondary || "rgba(0, 0, 0, 0.55)" : theme?.palette?.text?.contrastSecondary || "rgba(255, 255, 255, 0.7)";
  const inactiveHoverBg = isLight ? theme?.palette?.action?.hover || "rgba(0, 0, 0, 0.04)" : "rgba(255, 255, 255, 0.08)";
  return {
    stack: css8`
      display: flex;
      flex-direction: column;
      gap: 4px;
      padding: 4px;
    `,
    btn: css8`
      display: flex;
      align-items: center;
      justify-content: center;
      width: 32px;
      height: 32px;
      padding: 0;
      border: none;
      background: transparent;
      border-radius: 6px;
      cursor: pointer;
      transition: background-color 150ms ease, color 150ms ease;
    `,
    btnActive: css8`
      background-color: ${primaryFaded};
      color: ${primaryMain};

      &:hover {
        background-color: ${primaryFaded};
      }
    `,
    btnInactive: css8`
      color: ${inactiveFg};

      &:hover {
        background-color: ${inactiveHoverBg};
      }
    `
  };
};
var MapControls_default = MapControls;

// src/internal/maps/MapNavigation.tsx
import React11 from "react";
import { css as css9, cx as cx2 } from "@emotion/css";
import { useTheme as useTheme9, Tooltip as Tooltip3 } from "@mui/material";
import { BiPlus, BiMinus } from "react-icons/bi";
import {
  MdOpenWith,
  MdClose,
  MdKeyboardArrowUp,
  MdKeyboardArrowDown,
  MdKeyboardArrowLeft,
  MdKeyboardArrowRight
} from "react-icons/md";
import { useMap as useMap2 } from "@vis.gl/react-google-maps";
import { Fragment as Fragment6, jsx as jsx18, jsxs as jsxs11 } from "react/jsx-runtime";
var PAN_DISTANCE_PX = 100;
var MapNavigation = ({ style, className, mapId }) => {
  const theme = useTheme9();
  const { mode } = useMapPreferences();
  const surface = useMapSurfaceColors();
  const cls = useStyles9(theme, mode, surface.divider);
  const map = useMap2(mapId);
  const [isOpen, setIsOpen] = React11.useState(false);
  const panBy = (x, y) => map?.panBy(x, y);
  const zoomIn = () => map?.setZoom((map.getZoom() ?? 10) + 1);
  const zoomOut = () => map?.setZoom((map.getZoom() ?? 10) - 1);
  const togglePositionStyle = { bottom: 24, right: 10, ...style };
  const controlsPositionStyle = { bottom: 24, right: 58, ...style };
  const toggleButton = /* @__PURE__ */ jsx18(Tooltip3, { title: isOpen ? "Close navigation controls" : "Open navigation controls", placement: "left", children: /* @__PURE__ */ jsx18(
    "button",
    {
      type: "button",
      "aria-label": isOpen ? "Close navigation controls" : "Open navigation controls",
      "aria-expanded": isOpen,
      onClick: () => setIsOpen((v) => !v),
      className: isOpen ? cls.btnActive : cls.btnInactive,
      children: isOpen ? /* @__PURE__ */ jsx18(MdClose, { size: 18 }) : /* @__PURE__ */ jsx18(MdOpenWith, { size: 18 })
    }
  ) });
  return /* @__PURE__ */ jsxs11(Fragment6, { children: [
    isOpen && /* @__PURE__ */ jsx18(GoogleMapsElement_default, { style: controlsPositionStyle, disablePadding: true, children: /* @__PURE__ */ jsxs11("div", { className: cls.controlsRow, children: [
      /* @__PURE__ */ jsxs11("div", { className: cls.pad, children: [
        /* @__PURE__ */ jsx18(Tooltip3, { title: "Pan left", placement: "left", children: /* @__PURE__ */ jsx18(
          "button",
          {
            type: "button",
            "aria-label": "Pan left",
            onClick: () => panBy(-PAN_DISTANCE_PX, 0),
            className: cx2(cls.btnInactive, cls.padLeft),
            children: /* @__PURE__ */ jsx18(MdKeyboardArrowLeft, { size: 22 })
          }
        ) }),
        /* @__PURE__ */ jsx18(Tooltip3, { title: "Pan up", placement: "top", children: /* @__PURE__ */ jsx18(
          "button",
          {
            type: "button",
            "aria-label": "Pan up",
            onClick: () => panBy(0, -PAN_DISTANCE_PX),
            className: cx2(cls.btnInactive, cls.padUp),
            children: /* @__PURE__ */ jsx18(MdKeyboardArrowUp, { size: 22 })
          }
        ) }),
        /* @__PURE__ */ jsx18(Tooltip3, { title: "Pan right", placement: "right", children: /* @__PURE__ */ jsx18(
          "button",
          {
            type: "button",
            "aria-label": "Pan right",
            onClick: () => panBy(PAN_DISTANCE_PX, 0),
            className: cx2(cls.btnInactive, cls.padRight),
            children: /* @__PURE__ */ jsx18(MdKeyboardArrowRight, { size: 22 })
          }
        ) }),
        /* @__PURE__ */ jsx18(Tooltip3, { title: "Pan down", placement: "bottom", children: /* @__PURE__ */ jsx18(
          "button",
          {
            type: "button",
            "aria-label": "Pan down",
            onClick: () => panBy(0, PAN_DISTANCE_PX),
            className: cx2(cls.btnInactive, cls.padDown),
            children: /* @__PURE__ */ jsx18(MdKeyboardArrowDown, { size: 22 })
          }
        ) })
      ] }),
      /* @__PURE__ */ jsxs11("div", { className: cls.zoomStack, children: [
        /* @__PURE__ */ jsx18(Tooltip3, { title: "Zoom in", placement: "left", children: /* @__PURE__ */ jsx18("button", { type: "button", "aria-label": "Zoom in", onClick: zoomIn, className: cls.btnInactive, children: /* @__PURE__ */ jsx18(BiPlus, { size: 20 }) }) }),
        /* @__PURE__ */ jsx18(Tooltip3, { title: "Zoom out", placement: "left", children: /* @__PURE__ */ jsx18("button", { type: "button", "aria-label": "Zoom out", onClick: zoomOut, className: cls.btnInactive, children: /* @__PURE__ */ jsx18(BiMinus, { size: 20 }) }) })
      ] })
    ] }) }),
    /* @__PURE__ */ jsx18(GoogleMapsElement_default, { style: togglePositionStyle, className, disablePadding: true, children: /* @__PURE__ */ jsx18("div", { className: cls.collapsedStack, children: toggleButton }) })
  ] });
};
var useStyles9 = (theme, mode, dividerColor) => {
  const primaryMain = theme?.palette?.primary?.main || "#1976d2";
  const primaryFaded = `${primaryMain}20`;
  const isLight = mode === "light";
  const inactiveFg = isLight ? theme?.palette?.text?.secondary || "rgba(0, 0, 0, 0.55)" : theme?.palette?.text?.contrastSecondary || "rgba(255, 255, 255, 0.7)";
  const inactiveHoverBg = isLight ? theme?.palette?.action?.hover || "rgba(0, 0, 0, 0.04)" : "rgba(255, 255, 255, 0.08)";
  const btnBase = css9`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    padding: 0;
    border: none;
    background: transparent;
    border-radius: 6px;
    cursor: pointer;
    transition: background-color 150ms ease, color 150ms ease;
  `;
  return {
    collapsedStack: css9`
      display: flex;
      flex-direction: column;
      gap: 4px;
      padding: 4px;
    `,
    controlsRow: css9`
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 6px;
      padding: 4px;
    `,
    pad: css9`
      display: grid;
      grid-template-columns: repeat(3, 32px);
      grid-template-rows: repeat(2, 32px);
      gap: 4px 2px;
    `,
    padUp: css9`
      grid-column: 2;
      grid-row: 1;
    `,
    padDown: css9`
      grid-column: 2;
      grid-row: 2;
    `,
    padLeft: css9`
      grid-column: 1;
      grid-row: 1 / span 2;
      align-self: center;
    `,
    padRight: css9`
      grid-column: 3;
      grid-row: 1 / span 2;
      align-self: center;
    `,
    zoomStack: css9`
      display: flex;
      flex-direction: column;
      gap: 4px;
      border-left: 1px solid ${dividerColor || "rgba(255, 255, 255, 0.1)"};
      padding-left: 6px;
    `,
    btnInactive: cx2(
      btnBase,
      css9`
        color: ${inactiveFg};
        &:hover {
          background-color: ${inactiveHoverBg};
        }
      `
    ),
    btnActive: cx2(
      btnBase,
      css9`
        background-color: ${primaryFaded};
        color: ${primaryMain};
        &:hover {
          background-color: ${primaryFaded};
        }
      `
    )
  };
};
var MapNavigation_default = MapNavigation;

// src/internal/maps/mapGeometry.ts
var getMidpointCenter = (a, b) => {
  if (a && b) {
    return { lat: (a.lat + b.lat) / 2, lng: (a.lng + b.lng) / 2 };
  }
  return a || b || { lat: 0, lng: 0 };
};
var getZoomForSpan = (a, b) => {
  if (!a || !b) return 15;
  const latDiff = Math.abs(a.lat - b.lat);
  const lngDiff = Math.abs(a.lng - b.lng);
  const maxDiff = Math.max(latDiff, lngDiff);
  if (maxDiff > 0.5) return 10;
  if (maxDiff > 0.2) return 11;
  if (maxDiff > 0.1) return 12;
  if (maxDiff > 0.05) return 13;
  return 14;
};

// src/internal/maps/useMapRoute.ts
import React12 from "react";
import { useMap as useMap3, useMapsLibrary } from "@vis.gl/react-google-maps";
import { useTheme as useTheme10 } from "@mui/material";
var useMapRoute = ({
  mapId,
  pickup,
  delivery,
  enabled = true,
  strokeColor,
  fitBounds = true,
  fitBoundsPadding = 50,
  onLoadingChange,
  onRouteComputed,
  onError
}) => {
  const theme = useTheme10();
  const map = useMap3(mapId);
  const googleMapsService = useMapsLibrary("maps");
  const directionsServiceRef = React12.useRef(null);
  const routeMainRef = React12.useRef(null);
  const lightLayersRef = React12.useRef([]);
  const animationFrameRef = React12.useRef(0);
  const onLoadingChangeRef = React12.useRef(onLoadingChange);
  const onRouteComputedRef = React12.useRef(onRouteComputed);
  const onErrorRef = React12.useRef(onError);
  React12.useEffect(() => {
    onLoadingChangeRef.current = onLoadingChange;
    onRouteComputedRef.current = onRouteComputed;
    onErrorRef.current = onError;
  }, [onLoadingChange, onRouteComputed, onError]);
  React12.useEffect(() => {
    if (!googleMapsService) return;
    directionsServiceRef.current = new window.google.maps.DirectionsService();
  }, [googleMapsService]);
  const clearRoute = React12.useCallback(() => {
    if (animationFrameRef.current) {
      cancelAnimationFrame(animationFrameRef.current);
      animationFrameRef.current = 0;
    }
    if (routeMainRef.current) {
      routeMainRef.current.setMap(null);
      routeMainRef.current = null;
    }
    for (const layer of lightLayersRef.current) {
      layer.setMap(null);
    }
    lightLayersRef.current = [];
  }, []);
  const pickupLat = pickup?.lat;
  const pickupLng = pickup?.lng;
  const deliveryLat = delivery?.lat;
  const deliveryLng = delivery?.lng;
  React12.useEffect(() => {
    if (!map) return;
    if (!enabled || pickupLat == null || pickupLng == null || deliveryLat == null || deliveryLng == null) {
      clearRoute();
      onErrorRef.current?.(null);
      return;
    }
    if (fitBounds) {
      const bounds = new window.google.maps.LatLngBounds();
      bounds.extend({ lat: pickupLat, lng: pickupLng });
      bounds.extend({ lat: deliveryLat, lng: deliveryLng });
      map.fitBounds(bounds, {
        top: fitBoundsPadding,
        bottom: fitBoundsPadding,
        left: fitBoundsPadding,
        right: fitBoundsPadding
      });
    }
    const directionsService = directionsServiceRef.current;
    if (!directionsService) return;
    let aborted = false;
    clearRoute();
    const routeColor = strokeColor || theme?.palette?.primary?.main || "#2080ff";
    onLoadingChangeRef.current?.(true);
    onErrorRef.current?.(null);
    directionsService.route(
      {
        origin: `${pickupLat},${pickupLng}`,
        destination: `${deliveryLat},${deliveryLng}`,
        travelMode: google.maps.TravelMode.DRIVING
      },
      (res, status) => {
        onLoadingChangeRef.current?.(false);
        if (aborted) return;
        if (status !== "OK" || !res) {
          console.error("Directions request failed: " + status);
          onErrorRef.current?.(status);
          return;
        }
        const leg = res.routes[0]?.legs?.[0];
        if (leg) {
          onRouteComputedRef.current?.({
            durationSec: leg.duration?.value ?? 0,
            distanceMeters: leg.distance?.value ?? 0
          });
        }
        const routePath = res.routes[0].overview_path.map((p) => ({
          lat: p.lat(),
          lng: p.lng()
        }));
        if (routePath.length < 2) return;
        routeMainRef.current = new google.maps.Polyline({
          path: routePath,
          geodesic: true,
          strokeColor: routeColor,
          strokeWeight: 5,
          strokeOpacity: 1,
          zIndex: 3,
          clickable: false,
          map
        });
        const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        const totalPoints = routePath.length;
        const LAYER_COUNT = 12;
        const LIGHT_WINDOW = Math.max(Math.floor(totalPoints * 0.24), 8);
        const LAYER_OPACITY = 0.08;
        const gradientLayers = [];
        for (let i = 0; i < LAYER_COUNT; i++) {
          gradientLayers.push(
            new google.maps.Polyline({
              path: [],
              geodesic: true,
              strokeColor: "#ffffff",
              strokeWeight: 5,
              strokeOpacity: LAYER_OPACITY,
              zIndex: 5,
              clickable: false,
              visible: false,
              map
            })
          );
        }
        lightLayersRef.current = gradientLayers;
        if (!prefersReducedMotion) {
          const totalTravel = totalPoints + LIGHT_WINDOW;
          const TARGET_CYCLE_SECONDS = 4;
          const SPEED = totalTravel / (TARGET_CYCLE_SECONDS * 60);
          let position = 0;
          const animate = () => {
            position = (position + SPEED) % totalTravel;
            const centerIdx = Math.floor(position);
            for (let i = 0; i < LAYER_COUNT; i++) {
              const halfSpan = Math.max(1, Math.floor(LIGHT_WINDOW / 2 * (LAYER_COUNT - i) / LAYER_COUNT));
              const segStart = Math.max(0, centerIdx - halfSpan);
              const segEnd = Math.min(totalPoints - 1, centerIdx + halfSpan);
              const segPath = routePath.slice(segStart, segEnd + 1);
              if (segPath.length >= 2) {
                gradientLayers[i].setPath(segPath);
                gradientLayers[i].setVisible(true);
              } else {
                gradientLayers[i].setVisible(false);
              }
            }
            animationFrameRef.current = requestAnimationFrame(animate);
          };
          animationFrameRef.current = requestAnimationFrame(animate);
        }
      }
    );
    return () => {
      aborted = true;
      clearRoute();
    };
  }, [map, enabled, pickupLat, pickupLng, deliveryLat, deliveryLng, strokeColor, fitBounds, fitBoundsPadding]);
};

// src/components/RidehailDetailsMap.tsx
import { jsx as jsx19, jsxs as jsxs12 } from "react/jsx-runtime";
var RidehailDetailsMap = ({ ridehail }) => {
  const theme = useTheme11();
  const cls = useStyles10(theme);
  const { mapStyles: activeMapStyles } = useMapPreferences();
  const hasPickup = ridehail?.pickup_lat && ridehail?.pickup_lng;
  const hasDropoff = ridehail?.dropoff_lat && ridehail?.dropoff_lng;
  const pickupPosition = hasPickup ? { lat: Number(ridehail.pickup_lat), lng: Number(ridehail.pickup_lng) } : null;
  const dropoffPosition = hasDropoff ? { lat: Number(ridehail.dropoff_lat), lng: Number(ridehail.dropoff_lng) } : null;
  useMapRoute({
    mapId: "ridehail-details-map",
    pickup: pickupPosition,
    delivery: dropoffPosition
  });
  if (!hasPickup && !hasDropoff) {
    return /* @__PURE__ */ jsx19(Alert3, { severity: "info", children: "No map available - missing coordinates" });
  }
  const directionsUrl = hasPickup && hasDropoff ? `https://www.google.com/maps/dir/${ridehail.pickup_lat},${ridehail.pickup_lng}/${ridehail.dropoff_lat},${ridehail.dropoff_lng}` : hasPickup ? `https://maps.google.com/?q=${ridehail.pickup_lat},${ridehail.pickup_lng}` : `https://maps.google.com/?q=${ridehail.dropoff_lat},${ridehail.dropoff_lng}`;
  return /* @__PURE__ */ jsxs12("div", { className: cls.container, children: [
    /* @__PURE__ */ jsxs12("div", { className: cls.mapContainer, children: [
      /* @__PURE__ */ jsxs12(
        Map,
        {
          id: "ridehail-details-map",
          defaultCenter: getMidpointCenter(pickupPosition, dropoffPosition),
          defaultZoom: getZoomForSpan(pickupPosition, dropoffPosition),
          clickableIcons: false,
          gestureHandling: "cooperative",
          disableDefaultUI: true,
          styles: activeMapStyles,
          children: [
            pickupPosition && /* @__PURE__ */ jsx19(LocationPinMarker_default, { mapId: "ridehail-details-map", markerId: "pickup", position: pickupPosition }),
            dropoffPosition && /* @__PURE__ */ jsx19(LocationPinMarker_default, { mapId: "ridehail-details-map", markerId: "delivery", position: dropoffPosition })
          ]
        }
      ),
      /* @__PURE__ */ jsx19(MapControls_default, {}),
      /* @__PURE__ */ jsx19(MapNavigation_default, { mapId: "ridehail-details-map" })
    ] }),
    /* @__PURE__ */ jsx19("div", { className: cls.actions, children: /* @__PURE__ */ jsx19("a", { href: directionsUrl, target: "_blank", rel: "noopener noreferrer", children: /* @__PURE__ */ jsx19(Button2, { variant: "contained", color: "secondary", size: "small", fullWidth: true, children: "View Route in Maps" }) }) })
  ] });
};
var useStyles10 = (theme) => ({
  container: css10`
    display: flex;
    flex-direction: column;
    gap: ${theme?.spacing(2)};
  `,
  mapContainer: css10`
    position: relative;
    width: 100%;
    height: 450px;
    border: 1px solid ${theme?.palette.divider};
    border-radius: 8px;
    overflow: hidden;
  `,
  actions: css10`
    display: flex;
    justify-content: center;
  `
});
var RidehailDetailsMap_default = RidehailDetailsMap;

// src/lib/formatPhone.ts
var formatPhone = (str = void 0, options = {}) => {
  const { removeInternationalCode = false } = options;
  if (str) {
    const cleansedStr = `${str}`.replace(/\D/g, "");
    const match = cleansedStr.match(/^(\d{1})?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      const intlCode = match[1] ? `+${match[1]} ` : "";
      return [removeInternationalCode ? "" : intlCode, "(", match[2], ")\xA0", match[3], "-\u2060", match[4]].join("");
    }
  }
  return str;
};

// src/lib/terminalState.ts
var TERMINAL_RIDEHAIL_STATUSES = /* @__PURE__ */ new Set([
  "completed",
  "droppedoff",
  "dropped_off",
  "canceled",
  "cancelled",
  "failed"
]);
function isRidehailTerminal(input) {
  const ridehailStatus = input.ridehailStatus?.toLowerCase();
  const moveStatus = input.moveStatus?.toLowerCase();
  return !!ridehailStatus && TERMINAL_RIDEHAIL_STATUSES.has(ridehailStatus) || moveStatus === "delivery successful" || !!input.cancelStatus;
}

// src/components/RidehailDetailsView.tsx
import { Fragment as Fragment7, jsx as jsx20, jsxs as jsxs13 } from "react/jsx-runtime";
var RidehailDetailsView = ({ move, onRefetch, renderToolbar }) => {
  const navigate = useNavigate();
  const host = useRidehailsHost();
  const theme = useTheme12();
  const cls = useStyles11(theme);
  const ridehail = move.ridehails?.[0] ?? void 0;
  React13.useEffect(() => {
    const isTerminalState = isRidehailTerminal({
      ridehailStatus: ridehail?.status,
      moveStatus: move.status,
      cancelStatus: move.cancel_status
    });
    if (isTerminalState) {
      return;
    }
    const interval = setInterval(() => {
      onRefetch();
    }, 3e3);
    return () => clearInterval(interval);
  }, [ridehail?.status, move.status, move.cancel_status, onRefetch]);
  const getDisplayStatus = () => {
    const pickupTime = ridehail?.pickup_at || move.pickup_time;
    const hasStatus = ridehail?.status || move.status;
    if (move.cancel_status) return `Canceled: ${move.cancel_reason || "Unknown"}`;
    if ((!hasStatus || hasStatus.toLowerCase() === "not called") && pickupTime && isPickupWithinLastDay(pickupTime)) {
      return "Pending";
    }
    return formatStatus(hasStatus || "");
  };
  const getVehicleInfo = () => {
    if (!ridehail) return null;
    const parts = [];
    if (ridehail.vehicle_year) parts.push(ridehail.vehicle_year);
    if (ridehail.vehicle_make) parts.push(ridehail.vehicle_make);
    if (ridehail.vehicle_model) parts.push(ridehail.vehicle_model);
    if (ridehail.vehicle_color) parts.push(`(${ridehail.vehicle_color})`);
    return parts.length > 0 ? parts.join(" ") : null;
  };
  const toolbarContent = /* @__PURE__ */ jsxs13("div", { className: cls.toolbarContent, children: [
    ridehail?.provider && getProviderChip(ridehail.provider),
    /* @__PURE__ */ jsx20(
      Button3,
      {
        variant: "outlined",
        onClick: () => navigate(host.moveHref(move.parent_move_id ?? move.id)),
        size: "small",
        children: "View Move"
      }
    ),
    /* @__PURE__ */ jsx20(RidehailActions_default, { move, ridehail, onRefetch })
  ] });
  return /* @__PURE__ */ jsx20("div", { className: cls.root, children: /* @__PURE__ */ jsxs13(Container, { maxWidth: "xl", children: [
    renderToolbar(toolbarContent),
    /* @__PURE__ */ jsx20(Spacer_default, {}),
    /* @__PURE__ */ jsx20(Paper, { variant: "custom", className: cls.paper, children: /* @__PURE__ */ jsxs13("div", { className: cls.mainLayout, children: [
      ridehail && (ridehail.pickup_lat || ridehail.dropoff_lat) ? /* @__PURE__ */ jsx20("div", { className: cls.mapSection, children: /* @__PURE__ */ jsx20(RidehailDetailsMap_default, { ridehail }) }) : null,
      /* @__PURE__ */ jsxs13("div", { className: cls.infoSection, children: [
        /* @__PURE__ */ jsx20("div", { className: cls.infoHeader, children: /* @__PURE__ */ jsx20(
          Chip3,
          {
            color: getStatusColor({ ...ridehail, move }),
            label: getDisplayStatus(),
            icon: getStatusIcon({ ...ridehail, move })
          }
        ) }),
        ridehail ? /* @__PURE__ */ jsxs13(Fragment7, { children: [
          /* @__PURE__ */ jsx20(Spacer_default, {}),
          (ridehail.driver_photo_url || ridehail.driver_name || ridehail.driver_phone || ridehail.driver_rating || ridehail.vehicle_photo_url || getVehicleInfo() || ridehail.vehicle_license_plate) && /* @__PURE__ */ jsxs13(Fragment7, { children: [
            /* @__PURE__ */ jsxs13("div", { className: cls.sectionFlex, children: [
              /* @__PURE__ */ jsx20("div", { className: cls.sectionFlexItem, children: (ridehail.driver_photo_url || ridehail.driver_name || ridehail.driver_phone || ridehail.driver_rating) && /* @__PURE__ */ jsxs13("div", { className: cls.photoCard, children: [
                ridehail.driver_photo_url && /* @__PURE__ */ jsx20("img", { src: ridehail.driver_photo_url, alt: "Driver", className: cls.photo }),
                /* @__PURE__ */ jsxs13("div", { className: cls.photoLabel, children: [
                  ridehail.driver_name && /* @__PURE__ */ jsx20(InfoItem_default, { size: "sm", keyText: "Rideshare Driver", valueText: ridehail.driver_name }),
                  ridehail.driver_phone && /* @__PURE__ */ jsx20(
                    InfoItem_default,
                    {
                      size: "sm",
                      keyText: "Contact Number",
                      valueText: formatPhone(ridehail.driver_phone)
                    }
                  ),
                  ridehail.driver_rating && /* @__PURE__ */ jsx20(
                    InfoItem_default,
                    {
                      size: "sm",
                      keyText: "Rating",
                      valueText: `\u2B50 ${ridehail.driver_rating.toFixed(1)}`
                    }
                  )
                ] })
              ] }) }),
              /* @__PURE__ */ jsx20("div", { className: cls.sectionFlexItem, children: (ridehail.vehicle_photo_url || getVehicleInfo()) && /* @__PURE__ */ jsxs13("div", { className: cls.photoCard, children: [
                ridehail.vehicle_photo_url && /* @__PURE__ */ jsx20("img", { src: ridehail.vehicle_photo_url, alt: "Vehicle", className: cls.photo }),
                getVehicleInfo() !== null && /* @__PURE__ */ jsxs13("div", { className: cls.photoLabel, children: [
                  /* @__PURE__ */ jsx20(InfoItem_default, { size: "sm", keyText: "Vehicle", valueText: getVehicleInfo() || "N/A" }),
                  ridehail.vehicle_license_plate && /* @__PURE__ */ jsx20(
                    InfoItem_default,
                    {
                      size: "sm",
                      keyText: "License Plate",
                      valueText: ridehail.vehicle_license_plate || "N/A"
                    }
                  )
                ] })
              ] }) })
            ] }),
            /* @__PURE__ */ jsx20(Spacer_default, {})
          ] }),
          /* @__PURE__ */ jsx20(Typography6, { className: cls.sectionTitle, children: "Product Information" }),
          /* @__PURE__ */ jsxs13("div", { className: cls.sectionFlex, children: [
            /* @__PURE__ */ jsx20("div", { className: cls.sectionFlexItem, children: /* @__PURE__ */ jsx20(
              InfoItem_default,
              {
                size: "sm",
                keyText: "Product Type",
                valueText: capitalizeWords(ridehail.product_type) || "N/A"
              }
            ) }),
            /* @__PURE__ */ jsx20("div", { className: cls.sectionFlexItem, children: ridehail.actual_price ? /* @__PURE__ */ jsx20(InfoItem_default, { size: "sm", keyText: "Estimated Price Range", valueText: getPriceRange(ridehail) || "N/A" }) : /* @__PURE__ */ jsx20(InfoItem_default, { size: "sm", keyText: "Price", valueText: "N/A" }) })
          ] }),
          /* @__PURE__ */ jsx20(Spacer_default, {}),
          /* @__PURE__ */ jsx20(Typography6, { className: cls.sectionTitle, children: "Trip Timeline" }),
          /* @__PURE__ */ jsxs13("div", { className: cls.sectionFlex, children: [
            /* @__PURE__ */ jsxs13("div", { className: cls.sectionFlexItem, children: [
              /* @__PURE__ */ jsx20(InfoItem_default, { size: "sm", keyText: "Booked At", valueText: formatTime(ridehail.booked_at) || "N/A" }),
              /* @__PURE__ */ jsx20(
                InfoItem_default,
                {
                  size: "sm",
                  keyText: "Assigned At",
                  valueText: formatTime(ridehail.driver_assigned_at) || "N/A"
                }
              )
            ] }),
            /* @__PURE__ */ jsxs13("div", { className: cls.sectionFlexItem, children: [
              /* @__PURE__ */ jsx20(InfoItem_default, { size: "sm", keyText: "Pickup Time", valueText: formatTime(ridehail.pickup_at) || "N/A" }),
              /* @__PURE__ */ jsx20(InfoItem_default, { size: "sm", keyText: "Dropoff Time", valueText: formatTime(ridehail.dropoff_at) || "N/A" })
            ] })
          ] }),
          /* @__PURE__ */ jsx20(Spacer_default, {}),
          /* @__PURE__ */ jsx20(Typography6, { className: cls.sectionTitle, children: "Locations" }),
          /* @__PURE__ */ jsxs13("div", { className: cls.sectionFlex, children: [
            /* @__PURE__ */ jsx20("div", { className: cls.sectionFlexItem, children: /* @__PURE__ */ jsx20(
              InfoItem_default,
              {
                size: "sm",
                keyText: "Pickup Address",
                valueText: ridehail.pickup_address || move.lane?.pickup?.address || "N/A"
              }
            ) }),
            /* @__PURE__ */ jsx20("div", { className: cls.sectionFlexItem, children: /* @__PURE__ */ jsx20(
              InfoItem_default,
              {
                size: "sm",
                keyText: "Dropoff Address",
                valueText: ridehail.dropoff_address || move.lane?.delivery?.address || "N/A"
              }
            ) })
          ] }),
          /* @__PURE__ */ jsx20(Spacer_default, {}),
          /* @__PURE__ */ jsx20(Typography6, { className: cls.sectionTitle, children: "Associated Move Information" }),
          /* @__PURE__ */ jsxs13("div", { className: cls.sectionFlex, children: [
            /* @__PURE__ */ jsxs13("div", { className: cls.sectionFlexItem, children: [
              /* @__PURE__ */ jsx20(InfoItem_default, { size: "sm", keyText: "Driver", valueText: move.driver?.user?.display_name || "N/A" }),
              /* @__PURE__ */ jsx20(InfoItem_default, { size: "sm", keyText: "Move ID", valueText: move.parentMove?.id || "N/A" }),
              /* @__PURE__ */ jsx20(InfoItem_default, { size: "sm", keyText: "Rooftop", valueText: move.customer?.name || "N/A" }),
              move.parentMove?.consumer_name && /* @__PURE__ */ jsx20(InfoItem_default, { size: "sm", keyText: "Consumer", valueText: move.parentMove?.consumer_name || "N/A" })
            ] }),
            /* @__PURE__ */ jsxs13("div", { className: cls.sectionFlexItem, children: [
              /* @__PURE__ */ jsx20(
                InfoItem_default,
                {
                  size: "sm",
                  keyText: "Driver Phone",
                  valueText: formatPhone(move.driver?.user?.phone ?? void 0) || "N/A"
                }
              ),
              /* @__PURE__ */ jsx20(InfoItem_default, { size: "sm", keyText: "VIN", valueText: move.parentMove?.vehicle_vin || "N/A" }),
              /* @__PURE__ */ jsx20(
                InfoItem_default,
                {
                  size: "sm",
                  keyText: "Vehicle",
                  valueText: [move.parentMove?.vehicle_year, move.parentMove?.vehicle_make, move.parentMove?.vehicle_model].filter(Boolean).join(" ") || "N/A"
                }
              ),
              move.parentMove?.consumer_phone && /* @__PURE__ */ jsx20(
                InfoItem_default,
                {
                  size: "sm",
                  keyText: "Consumer Phone",
                  valueText: formatPhone(move.parentMove?.consumer_phone) || "N/A"
                }
              )
            ] })
          ] })
        ] }) : /* @__PURE__ */ jsx20(Alert4, { severity: "info", children: "Rideshare has not been booked for this move." })
      ] })
    ] }) })
  ] }) });
};
var useStyles11 = (theme) => ({
  root: css11`
    display: block;
    position: relative;
    padding-top: ${theme?.spacing(4)};
    padding-bottom: ${theme?.spacing(4)};
    @media (max-width: ${theme?.breakpoints.values.sm}px) {
      padding-top: ${theme?.spacing(3)};
      padding-bottom: ${theme?.spacing(3)};
    }
  `,
  toolbarContent: css11`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    flex: 1;
  `,
  paper: css11`
    padding: 18px;
  `,
  mainLayout: css11`
    display: grid;
    grid-template-columns: 500px 1fr;
    gap: ${theme?.spacing(3)};
    @media (max-width: ${theme?.breakpoints.values.lg}px) {
      grid-template-columns: 1fr;
    }
  `,
  mapSection: css11`
    display: flex;
    flex-direction: column;
  `,
  infoSection: css11`
    position: relative;
    padding-top: 40px;
  `,
  infoHeader: css11`
    position: absolute;
    top: 0;
    right: 0;
  `,
  sectionTitle: css11`
    line-height: 1;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 12px;
  `,
  sectionFlex: css11`
    display: flex;
    gap: 20px;
  `,
  sectionFlexItem: css11`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 6px;
    word-break: break-word;
  `,
  photoSection: css11`
    display: flex;
    gap: 16px;
    flex-wrap: wrap;
  `,
  photoCard: css11`
    display: flex;
    flex-direction: column;
    gap: 8px;
    min-width: 150px;
  `,
  photo: css11`
    width: 150px;
    height: 150px;
    object-fit: cover;
    border-radius: 8px;
    border: 1px solid ${theme?.palette.divider};
  `,
  photoLabel: css11`
    display: flex;
    flex-direction: column;
    gap: 2px;
  `,
  rating: css11`
    color: ${theme?.palette.text.secondary};
    font-size: 0.875rem;
  `
});
var RidehailDetailsView_default = RidehailDetailsView;
export {
  RidehailActions_default as RidehailActions,
  RidehailDetailsMap_default as RidehailDetailsMap,
  RidehailDetailsView_default as RidehailDetailsView,
  RidehailsBoard_default as RidehailsBoard,
  RidehailsBoardData_default as RidehailsBoardData,
  RidehailsControls_default as RidehailsControls,
  RidehailsHostProvider,
  RidehailsMetrics_default as RidehailsMetrics,
  RidehailsProvider,
  RidehailsTable_default as RidehailsTable,
  capitalizeWords,
  formatPhone,
  formatStatus,
  formatTime,
  generateRidehailsCSV,
  getPriceRange,
  getProviderChip,
  getStatusColor,
  getStatusIcon,
  isPickupWithinLastDay,
  toRidehailRows,
  useRidehails,
  useRidehailsHost
};
//# sourceMappingURL=index.mjs.map